"use strict";
class DeveloperPropertyEoiPhaseController {
    constructor($scope, $localStorage, $window, $timeout, $filter, SSHttpService, SSConfigService, SSUtilService, SSAppService, SSAlertService, OTPService, SSConfirmationService, SSUserService, SettingsService, SSEoiService, SSEoiDiscountsService) {

        const self = this;

        self.$scope = $scope;
        self.$storage = $localStorage;
        self.$window = $window;
        self.$timeout = $timeout;
        self.$filter = $filter;

        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSUserService = SSUserService;
        self.SettingsService = SettingsService;
        self.SSEoiService = SSEoiService;
        self.SSEoiDiscountsService = SSEoiDiscountsService;

        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED;
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED;

        self.PROPERTY_TYPE_PRIVATE_CONDO = SHOWSUITE.PROPERTY_TYPE_PRIVATE_CONDO;
        self.PROPERTY_TYPE_EXECUTIVE_CONDO = SHOWSUITE.PROPERTY_TYPE_EXECUTIVE_CONDO;
        self.PROPERTY_TYPE_LANDED = SHOWSUITE.PROPERTY_TYPE_LANDED;
        self.PROPERTY_TYPE_APARTMENT = SHOWSUITE.PROPERTY_TYPE_APARTMENT;
        self.PROPERTY_TYPE_INTERGATED_DEVELOPMENT = SHOWSUITE.PROPERTY_TYPE_INTERGATED_DEVELOPMENT;
        self.PROPERTY_TYPE_COMMERCIAL = SHOWSUITE.PROPERTY_TYPE_COMMERCIAL;

        self.DISCOUNT_TYPE = {
            AMOUNT: 1,
            PERCENTAGE: 2
        };

        self.unitrequest = {};
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;

        self.AVAILABILITY_PUBLIC = SHOWSUITE.AVAILABILITY_PUBLIC;
        self.AVAILABILITY_BROKERS_ALL = SHOWSUITE.AVAILABILITY_BROKERS_ALL;
        self.AVAILABILITY_BROKERS_TEAM = SHOWSUITE.AVAILABILITY_BROKERS_TEAM;
        self.AVAILABILITY_TEAM_LEADS = SHOWSUITE.AVAILABILITY_TEAM_LEADS;

        self.SALE_STATUS_PENDING = SHOWSUITE.SALE_STATUS_PENDING;
        self.SALE_STATUS_SUBMITTED = SHOWSUITE.SALE_STATUS_SUBMITTED;
        self.SALE_STATUS_VERIFIED = SHOWSUITE.SALE_STATUS_VERIFIED;
        self.SALE_STATUS_APPROVED = SHOWSUITE.SALE_STATUS_APPROVED;
        self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
        self.SALE_STATUS_OTP = SHOWSUITE.SALE_STATUS_OTP;

        self.EOI_STATUS_DRAFT = SHOWSUITE.EOI_STATUS_DRAFT;
        self.EOI_STATUS_TRANSFERRED = SHOWSUITE.EOI_STATUS_TRANSFERRED;
        self.EOI_STATUS_SUBMITTED = SHOWSUITE.EOI_STATUS_SUBMITTED;
        self.EOI_STATUS_VERIFIED = SHOWSUITE.EOI_STATUS_VERIFIED;
        self.EOI_STATUS_WITHDRAWN = SHOWSUITE.EOI_STATUS_WITHDRAWN;
        self.EOI_STATUS_REJECTED = SHOWSUITE.EOI_STATUS_REJECTED;
        self.EOI_STATUS_REGISTERED = SHOWSUITE.EOI_STATUS_REGISTERED;
        self.EOI_STATUS_SUCCESSFUL = SHOWSUITE.EOI_STATUS_SUCCESSFUL;
        self.EOI_STATUS_UNSUCCESSFUL = SHOWSUITE.EOI_STATUS_UNSUCCESSFUL;
        self.EOI_STATUS_COMPLETED = SHOWSUITE.EOI_STATUS_COMPLETED;

        self.HOUSEHOLD_TYPE_FIRST_TIMER = SHOWSUITE.HOUSEHOLD_TYPE_FIRST_TIMER;
        self.HOUSEHOLD_TYPE_SECOND_TIMER = SHOWSUITE.HOUSEHOLD_TYPE_SECOND_TIMER;

        self.EOI_TYPE_SINGLE_PURCHASE = SHOWSUITE.EOI_TYPE_SINGLE_PURCHASE;
        self.EOI_TYPE_MULTIPLE_PURCHASE = SHOWSUITE.EOI_TYPE_MULTIPLE_PURCHASE;

        self.EOI_SELECTED_UNIT_STATUS_SELECTED = SHOWSUITE.EOI_SELECTED_UNIT_STATUS_SELECTED;
        self.EOI_SELECTED_UNIT_STATUS_COMPLETED = SHOWSUITE.EOI_SELECTED_UNIT_STATUS_COMPLETED;

        self.MARKETING_SCHEME_APPRECIATION_FEE = SHOWSUITE.MARKETING_SCHEME_APPRECIATION_FEE;
        self.MARKETING_SCHEME_BUYER_REFER_BUYER = SHOWSUITE.MARKETING_SCHEME_BUYER_REFER_BUYER;
        self.MARKETING_SCHEME_EXTERNAL_AGENT = SHOWSUITE.MARKETING_SCHEME_EXTERNAL_AGENT;
        self.MARKETING_SCHEME_JOINT_MARKETING_AGENCY = SHOWSUITE.MARKETING_SCHEME_JOINT_MARKETING_AGENCY;
        self.MARKETING_SCHEME_LOCAL_REFERRAL = SHOWSUITE.MARKETING_SCHEME_LOCAL_REFERRAL;
        self.MARKETING_SCHEME_LOCAL_REFERRAL_WITH_LOYALTY_BUYER = SHOWSUITE.MARKETING_SCHEME_LOCAL_REFERRAL_WITH_LOYALTY_BUYER;
        self.MARKETING_SCHEME_LOYALTY_BUYER = SHOWSUITE.MARKETING_SCHEME_LOYALTY_BUYER;
        self.MARKETING_SCHEME_LOYALTY_BUYER_WITH_EXTERNAL_AGENT = SHOWSUITE.MARKETING_SCHEME_LOYALTY_BUYER_WITH_EXTERNAL_AGENT;
        self.MARKETING_SCHEME_LOYALTY_BUYER_WITH_JOINT_MARKETING_AGENCY = SHOWSUITE.MARKETING_SCHEME_LOYALTY_BUYER_WITH_JOINT_MARKETING_AGENCY;
        self.MARKETING_SCHEME_OVERSEAS_REFERRAL = SHOWSUITE.MARKETING_SCHEME_OVERSEAS_REFERRAL;
        self.MARKETING_SCHEME_OVERSEAS_REFERRAL_WITH_LOYALTY_BUYER = SHOWSUITE.MARKETING_SCHEME_OVERSEAS_REFERRAL_WITH_LOYALTY_BUYER;
        self.MARKETING_SCHEME_STAFF_REFERRAL = SHOWSUITE.MARKETING_SCHEME_STAFF_REFERRAL;
        self.MARKETING_SCHEME_STAFF_PURCHASE = SHOWSUITE.MARKETING_SCHEME_STAFF_PURCHASE;
        self.MARKETING_SCHEME_EN_BLOC_PURCHASE = SHOWSUITE.MARKETING_SCHEME_EN_BLOC_PURCHASE;
        self.MARKETING_SCHEME_LARGE_UNITS = SHOWSUITE.MARKETING_SCHEME_LARGE_UNITS;
        self.MARKETING_SCHEME_VIP = SHOWSUITE.MARKETING_SCHEME_VIP;
        self.MARKETING_SCHEME_AGENT_PURCHASE = SHOWSUITE.MARKETING_SCHEME_AGENT_PURCHASE;

        self.ASSET_MODEL_AML_SCAN = SHOWSUITE.ASSET_MODEL_AML_SCAN;

        self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL = SHOWSUITE.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL;
        self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS = SHOWSUITE.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS;

        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
        self.BUYER_TYPE_COMPANY = SHOWSUITE.BUYER_TYPE_COMPANY;
        self.IDENTITY_TYPE_FOREIGNER = SHOWSUITE.IDENTITY_TYPE_FOREIGNER;
        self.PROPERTY_DOCUMENT_TYPE_FORM = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_FORM;

        self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION;

        self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM;
        self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PASSPORT;
        self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED;
        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
        self.PROPERTY_DOCUMENT_KIND_AML = SHOWSUITE.PROPERTY_DOCUMENT_KIND_AML;
        self.PROPERTY_DOCUMENT_KIND_SPA_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SPA_LETTER;
        self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS;
        self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;

        self.ASSET_MODEL_SALE_DOCUMENT = SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT;
        self.ASSET_MODEL_EOI_INSTRUMENT = SHOWSUITE.ASSET_MODEL_EOI_INSTRUMENT;
        self.ASSET_MODEL_PAYMENT_INSTRUMENT = SHOWSUITE.ASSET_MODEL_PAYMENT_INSTRUMENT;

        self.PROPERTY_DOCUMENT_TYPE_USER_DOC = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_USER_DOC;
        self.ASSET_MODEL_BUYER_DOCUMENT = SHOWSUITE.ASSET_MODEL_BUYER_DOCUMENT;

        self.PROPERTY_DOCUMENT_FORMAT_IMG = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_IMG;
        self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;
        self.ASSET_MODEL_EOI_DOCUMENT = SHOWSUITE.ASSET_MODEL_EOI_DOCUMENT;

        self.BENEFICIARY_IDENTITY_NRIC = SHOWSUITE.BENEFICIARY_IDENTITY_NRIC;
        self.BENEFICIARY_IDENTITY_PASSPORT = SHOWSUITE.BENEFICIARY_IDENTITY_PASSPORT;
        self.BENEFICIARY_IDENTITY_BIRTH_CERTIFICATE = SHOWSUITE.BENEFICIARY_IDENTITY_BIRTH_CERTIFICATE;

        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_PASSPORT;
        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_BIRTH_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_BIRTH_CERTIFICATE;

        self.DISCOUNT_TYPE_STANDARD = SHOWSUITE.DISCOUNT_TYPE_STANDARD;
        self.DISCOUNT_TYPE_STAFF = SHOWSUITE.DISCOUNT_TYPE_STAFF;
        self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE;
        self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE;
        self.DISCOUNT_TYPE_PROMO_CODE_OTHER = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_OTHER
        self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL;

        self.DISCOUNT_TYPE_AMOUNT = 1;
        self.DISCOUNT_TYPE_PERCENTAGE = 2;

        self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;
        self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;

        self.ROUNDING_METHOD_STANDARD = SHOWSUITE.ROUNDING_METHOD_STANDARD;
        self.ROUNDING_METHOD_FLOOR = SHOWSUITE.ROUNDING_METHOD_FLOOR;
        self.ROUNDING_METHOD_CEIL = SHOWSUITE.ROUNDING_METHOD_CEIL;

        self.ROUND_TO_ONE = SHOWSUITE.ROUND_TO_ONE;
        self.ROUND_TO_TEN = SHOWSUITE.ROUND_TO_TEN;
        self.ROUND_TO_HUNDRED = SHOWSUITE.ROUND_TO_HUNDRED;
        self.ROUND_TO_THOUSAND = SHOWSUITE.ROUND_TO_THOUSAND;

        self.TYPE_BUYER_VIEW = 'buyer_view';
        self.TYPE_DOCUMENT_VIEW = 'document_view';

        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
        self.BUYER_TYPE_COMPANY = SHOWSUITE.BUYER_TYPE_COMPANY;

        self.INSTRUMENT_TYPE_CHEQUE = SHOWSUITE.INSTRUMENT_TYPE_CHEQUE;

        self.LARAVEL_REPORT_SERVER_URL = SHOWSUITE.LARAVEL_REPORT_SERVER_URL;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;
        self.duplicate_eois = false;

        self.THAILAND_COUNTRY_CODE = 764;

        self.pageSize = 8; // Number of documents per page
        self.currentPage = 1; // Start with the first page

        self.payment_missing_document = false;

        self.fatf_blacklist_countries = [];
        self.cbi_rbi_countries = [];
        self.occupations_blacklist = {};

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.offset = 0;
        self.limit = 50;
        self.selectedRows = "" + self.limit;

        self.date_search = moment().format("DD/MM/YYYY");
        self.$timeout(function () {
            $(".datepicker").datepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: "dd/mm/yy",
            });
        });

        self.selected_eois = {};
        self.eois_count_for_emails = 0;

        self.agencyNames = [];
        self.eoisStatuses = [];
        self.payment_plans = [];

        // WEB-3643 — allocation-time "Customise payment plan" (mirrors AMS Team-IC).
        // Lets a developer edit a PVT base plan's clause %s + rule days while assigning a unit;
        // on Proceed the base plan is duplicated (customize endpoint) and the copy id is attached
        // inline via assign-units — same mechanism Team-IC uses, no sale required.
        self.PAYMENT_PLAN_TYPE_PVT = SHOWSUITE.PAYMENT_PLAN_TYPE_PVT;
        self.payment_types = self.SSConfigService.serverConfig.payment_types;
        self.const_dict_rule_names = self.SSConfigService.getPaymentPlanClauseRuleStartFromTypes();
        self.customise_payment_plan = false;     // true while the clause editor sub-view is shown
        self.customise_plan_obj = null;          // deep copy of the picked base plan being edited
        self.edit_percentage = false;            // true while clause %/rules are in edit mode
        self.changed_percentage = false;         // true once a customisation has been saved
        self.temp_payment_plan_clauses = null;   // snapshot for cancel
        self.payment_clause_error = "";          // inline validation message
        self.selected_unit_price_raw = 0;        // raw (unformatted) unit price for clause-value calc
        self.eoi_linked_payment_plans = [];      // UNFILTERED linked plans from the EOI list payload (incl. is_customize copies)
        self.popup_payment_plans = [];           // Assign Unit dropdown options: base plans + the EOI's current linked plan

        self.allEoisByPhase = null;
        self.amlSettings = null;
        self.eoiStatusesForExport = "10,11,20,30,60,70,80,90";
        // WEB-4461/WEB-4671: choices the EOI export counts - "all" (every choice) or "first" (1st choice only).
        self.eoiExportChoiceMode = 'all';
        self.initEOisStatuses();

        // Clear default x values
        self.data.property_id = self.data.property_id === 'x' ? null : self.data.property_id;
        self.data.phase_id = self.data.phase_id === 'x' ? null : parseInt(self.data.phase_id);

        self.getPropertyLaunches();
        self.getAgencies();
        self.loadInitData();
        self.getDeveloperSettings();



        self.HOUSEHOLD_TYPES = [
            {id: SHOWSUITE.HOUSEHOLD_TYPE_FIRST_TIMER, name: '1st Timer'},
            {id: SHOWSUITE.HOUSEHOLD_TYPE_SECOND_TIMER, name: '2nd Timer'}
        ];

        // WEB-3643 — `code` = short label shown in the EOI list MARKETING SCHEME column (full name on hover).
        self.MARKETING_SCHEMES = [
            {'id': self.MARKETING_SCHEME_APPRECIATION_FEE, 'name': 'Appreciation Fee', 'code': 'AF'},
            {'id': self.MARKETING_SCHEME_BUYER_REFER_BUYER, 'name': 'Buyer-Refer-Buyer', 'code': 'BRB'},
            {'id': self.MARKETING_SCHEME_EXTERNAL_AGENT, 'name': 'External Agent', 'code': 'EA'},
            {'id': self.MARKETING_SCHEME_JOINT_MARKETING_AGENCY, 'name': 'Joint Marketing Agency', 'code': 'JMA'},
            {'id': self.MARKETING_SCHEME_LOCAL_REFERRAL, 'name': 'Local Referral', 'code': 'LR'},
            {
                'id': self.MARKETING_SCHEME_LOCAL_REFERRAL_WITH_LOYALTY_BUYER,
                'name': 'Local Referral with Loyalty Buyer',
                'code': 'LR+LB'
            },
            {'id': self.MARKETING_SCHEME_LOYALTY_BUYER, 'name': 'Loyalty Buyer', 'code': 'LB'},
            {
                'id': self.MARKETING_SCHEME_LOYALTY_BUYER_WITH_EXTERNAL_AGENT,
                'name': 'Loyalty Buyer with External Agent',
                'code': 'LB+EA'
            },
            {
                'id': self.MARKETING_SCHEME_LOYALTY_BUYER_WITH_JOINT_MARKETING_AGENCY,
                'name': 'Loyalty Buyer with Joint Marketing Agency',
                'code': 'LB+JMA'
            },
            {'id': self.MARKETING_SCHEME_OVERSEAS_REFERRAL, 'name': 'Overseas Referral', 'code': 'OR'},
            {
                'id': self.MARKETING_SCHEME_OVERSEAS_REFERRAL_WITH_LOYALTY_BUYER,
                'name': 'Overseas Referral with Loyalty Buyer',
                'code': 'OR+LB'
            },
            {'id': self.MARKETING_SCHEME_STAFF_REFERRAL, 'name': 'Staff Referral', 'code': 'SR'},
            {'id': self.MARKETING_SCHEME_STAFF_PURCHASE, 'name': 'Staff Purchase', 'code': 'SP'},
            {'id': self.MARKETING_SCHEME_EN_BLOC_PURCHASE, 'name': 'En bloc Purchase', 'code': 'EBP'},
            {'id': self.MARKETING_SCHEME_LARGE_UNITS, 'name': 'Large units Purchase', 'code': 'LUP'},
            {'id': self.MARKETING_SCHEME_VIP, 'name': 'VIP Purchase', 'code': 'VIP'},
            {'id': self.MARKETING_SCHEME_AGENT_PURCHASE, 'name': 'Agent Purchase', 'code': 'AP'},
        ];
    }

    loadInitData() {
        const self = this;

        self.getUnits();
        self.getPaymentPlans();
        self.getPropertyQuestions();

        if (self.property) {
            self.amlSettings = self.SettingsService.getSetting(self.property.settings, 'aml');
            self.is_ec = self.property.type === self.PROPERTY_TYPE_EXECUTIVE_CONDO;
            let allowUnitAllocationForSubmittedEoisSetting = self.SettingsService.getSetting(self.property.settings, 'allow_unit_allocation_for_submitted_eois');

            if (self.property.property_launches) {
                self.current_property_launch = self.property.property_launches.find(x => x.id == self.data.phase_id);
                self.current_phase = self.SSUserService.getCurrentPhaseOfPropertyLaunch(self.current_property_launch);
            }
            if (allowUnitAllocationForSubmittedEoisSetting && allowUnitAllocationForSubmittedEoisSetting.value){
                self.allow_unit_allocation_for_submitted_eois = allowUnitAllocationForSubmittedEoisSetting.value;
            }
        }

        self.change_property = !(self.property); // If property loaded, hide the selection drop-downs
    }

    getPropertyLaunches() {
        const self = this;

        self.properties_list = null;
        self.property_launches_list = null;

        let url = 'sec/developer/properties/launches';
        let params = {
            summary: 1,
            include: 'properties'
        };

        //loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            //loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data)) {
                return;
            }

            self.properties_list = response.data.properties;
            self.property_launches_list = response.data.property_launches;
            self.property_launches_list_filtered = [];

            if (self.data.property_id) {
                $.each(self.properties_list, function (i, o) {
                    if (o.named_id == self.data.property_id) {
                        self.change_to_property_id = o.id; // Init current selection
                        self.applyPropertyChange();
                        return false; // break
                    }
                });
            } else if (self.properties_list.length === 1) { // If have only one property then default select it.
                self.change_to_property_id = self.properties_list[0].id; // Init with first property
                self.applyPropertyChange();
            }

            if (self.data.phase_id) { // If have phase_id in url params then default select it.
                self.change_to_property_launch_id = self.data.phase_id; // Init current selection
            }
        });
    }

    applyPropertyChange() {
        const self = this;

        self.property_launches_list_filtered = [];
        $.each(self.property_launches_list, function (i, o) {
            if (o.property_id == self.change_to_property_id) {
                self.property_launches_list_filtered.push(o);
            }
        });

        if (self.property_launches_list_filtered.length === 1) { // If have only one phase then default select it.
            self.change_to_property_launch_id = self.property_launches_list_filtered[0].id; // Init with first phase
        }
    }

    applyPropertyLaunchChange() {
        const self = this;

        if (self.change_to_property_id
            && self.change_to_property_launch_id
        ) {
            let change_to_property = null;
            $.each(self.properties_list, function (i, o) {
                if (o.id == self.change_to_property_id) {
                    change_to_property = o;
                    return false; // break
                }
            });

            self.data.property_id = change_to_property.named_id;
            self.data.phase_id = self.change_to_property_launch_id;

            self.getProperty();
        }
    }

    getProperty() {
        const self = this;

        if (!(self.data.property_id)) return;

        let url = 'properties/' + self.data.property_id;
        let params = {
            include: 'property_launches'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data)) {
                return;
            }

            self.data.property = response.data.property;
            self.property = response.data.property;
            self.loadInitData();
        });
    }

    getEoiPhase(show_loading = true) {
        const self = this;

        if (!self.data.property)
            return;

        let url = 'sec/eois';

        /** WEB-2880 DMS/AMS: EOIs Loading Issues
         * Need to remove after ticket is moved
        let include = "aml_scans, brokers, sale_status, buyers-cdd-acknowledgement, payment_plans, payments, eoi_units, question_answers"; **/
        // WEB-3643/WEB-3642 — payment_plan is fetched by id and UNFILTERED, so it includes the
        // per-booking customised copy (is_customize=1) that the selectable plan lists hide.
        // payment_plan_clauses attaches the clauses+rules to those plans so the customise editor can
        // render a linked copy's clauses when re-opened (otherwise it shows the name but no clauses).
        let include = "positive_aml_scans,buyers-cdd-acknowledgement,eoi_units,question_answers,aml_question_answers,payment_plan,payment_plan_clauses";

        self.allSales = {};

        let params = {
            offset: 0,
            limit: 10000,
            property_id: self.data.property.id,
            include: include + (self.duplicate_eois ? ",duplicate_eois" : ""),
            property_launch_id: self.data.phase_id,
            status: self.eoiStatusesForExport
        };

        loading(show_loading);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.allEoisByPhase = response.data.eois;

            // WEB-3643/WEB-3642 — the EOI list endpoint returns the linked plans at the response
            // ROOT (data.payment_plans), fetched by id and UNFILTERED, so it includes per-booking
            // customised copies (is_customize=1) that the selectable list hides. getPaymentPlan()
            // resolves each unit's plan from here (matched by unit.payment_plan_id).
            self.eoi_linked_payment_plans = response.data.payment_plans || [];

            if (self.duplicate_eois) {
                // Filter duplicate_eois if checkbox checked
                self.allEoisByPhase = self.allEoisByPhase.filter(e => e.duplicate_eois && e.duplicate_eois.length);

                $.each(self.allEoisByPhase, function (i, eoi) {
                    self.parseEoi(eoi);
                });
                self.allEoisMaster = angular.copy(self.allEoisByPhase)

                // Set View all if duplicates eoi checkbox checked
                self.selectedRows = '';
                self.limit = self.allEoisMaster.length;
                self.loadEois(1);
            } else {
                // Reset 50 rows if duplicates eoi checkbox unchecked
                self.selectedRows = '50';
                self.limit = parseInt(self.selectedRows);

                $.each(self.allEoisByPhase, function (i, eoi) {
                    self.parseEoi(eoi);
                });
                self.allEoisMaster = angular.copy(self.allEoisByPhase)
                self.loadEois(undefined, self.allEoisMaster);
            }
            self.$timeout(function () {
                self.$scope.$apply();
            });
        });
    }

    parseEoi(eoi) {
        const self = this;

        eoi.selected_unit = self.getSelectedUnit(eoi);
        if (!eoi.unit_id) {
            eoi.unit_id = eoi.selected_unit.unit_id;
        }
        if (eoi.unit_id) {
            eoi.unit_name = self.getUnitName(eoi.unit_id, false);
        }

        // WEB-3643/WEB-3642 — resolve the linked plan from self.eoi_linked_payment_plans (the
        // response-root data.payment_plans, UNFILTERED) so a per-booking customised copy resolves.
        eoi.payment_plan = self.getPaymentPlan(eoi);
        eoi.payment_plan_name = self.getPaymentPlanName(eoi);
        eoi.payment_plan_is_customized = !!(eoi.payment_plan && eoi.payment_plan.is_customize);

        if (eoi.calculated_agency_id && !self.agencyNames.find(x => x.id == eoi.calculated_agency_id)) {
            self.agencyNames.push({id: eoi.calculated_agency_id, name: self.getAgencyName(eoi.calculated_agency_id)});
        }
        if (!self.eoisStatuses.find(x => x.id == eoi.status)) {
            self.eoisStatuses.push({id: eoi.status, name: self.getEoiStatusName(eoi.status)});
        }

        $.each(eoi.buyers, function(i, buyer){
            if(buyer.cdd_acknowledgement == 0){
                eoi.show_cdd_acknowledgement = true;
            }
        });

        if (eoi.question_answers) {
            let risk_assessment_timestamp = null;

            $.each(eoi.question_answers, function (i, answer) {
                if (self.SSUtilService.compareQuestionMarker(answer.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL)) {
                    eoi.risk_assessment_level = answer.answer_text;
                    if (!risk_assessment_timestamp || risk_assessment_timestamp < answer.updated_at) {
                        risk_assessment_timestamp = answer.updated_at;
                    }
                }
                if (self.SSUtilService.compareQuestionMarker(answer.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS)) {
                    eoi.risk_assessment_remarks = answer.answer_text;
                    if (!risk_assessment_timestamp || risk_assessment_timestamp < answer.updated_at) {
                        risk_assessment_timestamp = answer.updated_at;
                    }
                }
            });

            // AML SCANS MODIFIED
            let aml_scan_timestamp = eoi.latest_aml_scans_created_date || null;
            /** WEB-2880 DMS/AMS: EOIs Loading Issues
             * Need remove after ticket is moved
             let aml_scan_timestamp = null;
             if (eoi.positive_aml_scans) {
                $.each(eoi.aml_scans, function (j, aml) {
                    if (!aml_scan_timestamp || aml_scan_timestamp < aml.created_at) {
                        aml_scan_timestamp = aml.created_at;
                    }
                });
             }**/

            // If AML changes timestamp is grater than risk assessment timestamp
            eoi.aml_scans_modified = aml_scan_timestamp > risk_assessment_timestamp;

            // WEB-4686: when the shown assessment was last saved — compared with the
            // server's `reviewed_at` (same rule: the later of level and remarks) on Review.
            eoi.risk_assessment_updated_at = risk_assessment_timestamp;
        }

        eoi.marketing_scheme_name = self.getMarketingSchemeName(eoi.marketing_scheme);
        eoi.marketing_scheme_code = self.getMarketingSchemeCode(eoi.marketing_scheme);
    }

    viewAMLDocument(aml) {
        const self = this;

        if (!(aml && aml.file_uri)) {
            return;
        }

        self.getPresignedUrl(
            self.ASSET_MODEL_AML_SCAN,
            aml.id,
            function (presignedUrl) {
                loading(false);
                if (presignedUrl) {
                    self.$window.open(presignedUrl, '_blank');
                }
            }
        );
    }

    getPropertyQuestions() {
        const self = this;

        if (!(self.property)) return;

        self.questions = [];

        //Get property questions
        let url = 'sec/developer/properties/' + self.property.id + '/questions';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let property_questions = response.data.property_questions.filter(item => item.is_active === 1);

            property_questions = _.sortBy(property_questions, "order");

            $.each(property_questions, function (index, question) {
                if (self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL)
                    || self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS))
                    self.questions.push(question);
            });
        });
    }

    viewDiscount(eoi, mode, index) {
        const self = this;

        self.scroll_index = index;
        self.EOI_DISCOUNTS_MODE = true;

        self.getEoi(eoi.id);
        self.getPropertyDiscounts(eoi.property_id);
    }

    getEoi(eoiId) {
        const self = this;

        self.selectedEoi = null;

        let url = 'sec/eois/' + eoiId;
        let params = {
            include: 'eoi_units, units, stacks, eoi_discounts' // payment_plans
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (!(response.data && response.data.eoi)) {
                return; // Skip, invalid data
            }

            // Response parsing
            $.each(response.data.eoi.eoi_units, function (index, eoi_unit) {
                if (response.data.units) {
                    eoi_unit.unit = response.data.units.find(x => x.id === eoi_unit.unit_id);
                    if (eoi_unit.unit && response.data.stacks) {
                        eoi_unit.unit.stack = response.data.stacks.find(x => x.id === eoi_unit.unit.stack_id);
                    }
                }
            });

            self.selectedEoi = response.data.eoi;

            self.prepareEoiUnitAppliedDiscounts();

            // The following methods require both eoi_discounts and property_discounts
            //self.calculateUnitSalePrices();
            self.linkEoiDiscountsWithPropertyDiscounts();
            self.applyStandardDiscounts();
        });
    }

    getPropertyDiscounts(property_id) {
        const self = this;

        self.property_discounts = [];

        let url = 'properties/' + property_id + '/property-discounts';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property_discounts = response.data.property_discounts;

            if (self.property_discounts) {
                $.each(self.property_discounts, function (index, property_discount) {
                    property_discount.display_name = self.SSConfigService.getDiscountTypeName(property_discount.type) + ' - ' + property_discount.name;
                });
            }

            // The following methods require both eoi_discounts and property_discounts
            self.linkEoiDiscountsWithPropertyDiscounts();
            //self.calculateUnitSalePrices();
            self.applyStandardDiscounts();
        });
    }

    linkEoiDiscountsWithPropertyDiscounts() {
        const self = this;

        if (!(self.selectedEoi && self.selectedEoi.eoi_discounts && self.property_discounts)) return; // Skip, missing data

        $.each(self.selectedEoi.eoi_discounts, function (index, eoiDiscount) {
            eoiDiscount.property_discount = self.property_discounts.find(x => x.id === eoiDiscount.property_discount_id);
        });
    }

    prepareEoiUnitAppliedDiscounts() {
        const self = this;

        if (!(self.selectedEoi && self.selectedEoi.eoi_discounts)) return; // Skip, missing data

        // Reset applied_discounts in EoiUnits
        $.each(self.selectedEoi.eoi_units, function (index, eoiUnit) {
            eoiUnit.applied_discounts = [];
        });

        $.each(self.selectedEoi.eoi_discounts, function (index, eoiDiscount) {
            let eoiUnit = self.selectedEoi.eoi_units.find(x => x.unit_id === eoiDiscount.unit_id);
            if (!eoiUnit) return; // Skip

            if (!(eoiUnit.applied_discounts.find(x => x.id === eoiDiscount.id))) {
                eoiUnit.applied_discounts.push(eoiDiscount);
            }
        });
    }

    getFieldVisibility(type) {
        const self = this;

        if (!type) {
            return false;
        }

        if (type == self.DISCOUNT_TYPE_STAFF
            || type == self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE
            || type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE
            || type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER
            || type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL) {
            return true;
        } else {
            if (!self.add_discount) self.add_discount = {};
            self.add_discount.code = null;

            return false;
        }
    }

    getFieldLabel(type) {
        const self = this;

        if (!type) {
            return false;
        }

        if (type == self.DISCOUNT_TYPE_STAFF) {
            return 'Staff ID';
        } else if (type == self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE
            || type == self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE
            || type == self.DISCOUNT_TYPE_PROMO_CODE_OTHER
            || type == self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL) {
            return 'Code';
        } else {
            self.selected_discount.code = null;
            return 'Code';
        }
    }

    applyStandardDiscounts() {
        const self = this;

        if (!(self.selectedEoi && self.selectedEoi.eoi_units && self.property_discounts)) return; // Skip, missing data

        //let standardPropertyDiscounts = self.property_discounts.find(x => x.type === self.DISCOUNT_TYPE_STANDARD);
        let standardPropertyDiscounts = self.SSEoiDiscountsService.getStandardDiscounts(self.property_discounts);
        if (!(standardPropertyDiscounts)) return; // Skip as no data

        let propertyDiscountsToApply = [];

        $.each(self.selectedEoi.eoi_units, function (i, eoiUnit) {
            $.each(standardPropertyDiscounts, function (index, propertyDiscount) {

                if (propertyDiscount.marketing_scheme
                    && propertyDiscount.marketing_scheme !== self.selectedEoi.marketing_scheme
                ) {
                    return; // Skip. This will only apply to assigned Marketing Scheme
                }

                if (!(self.SSEoiDiscountsService.isDiscountApplicable(eoiUnit.unit_id, propertyDiscount))) {
                    return; // Skip. This will only apply to assigned units
                }

                if (!eoiUnit.hasOwnProperty("applied_discounts") || !eoiUnit.applied_discounts) {
                    eoiUnit.applied_discounts = []; // Initialize
                }

                let appliedDiscount = eoiUnit.applied_discounts.find(x => x.property_discount_id === propertyDiscount.id);

                if (!appliedDiscount) {
                    propertyDiscountsToApply.push({
                        eoi_unit: eoiUnit,
                        property_discount: propertyDiscount
                    });
                }
            });
        });

        $.each(propertyDiscountsToApply, function (i, obj) {
            self.selected_unit_discount = obj.eoi_unit;
            self.add_discount = obj.property_discount;
            self.onAddDiscount(obj.property_discount, 'auto'); // Apply Discount
        });
    }

    onAddDiscount(discount, type = 'manual') {
        const self = this;

        if (!self.validateDiscount(discount)) {
            return;
        }

        // Check if discount available for selected unit
        if (!self.SSEoiDiscountsService.isDiscountApplicable(self.selected_unit_discount.unit_id, discount)) {
            self.SSAlertService.warning("Warning!", "This discount is not available for selected unit.");
            self.hideDiscountModal();
            return;
        }

        let url = 'sec/eois/' + self.selectedEoi.id + '/discounts/' + discount.id + '/apply';
        let params = {
            unit_id: self.selected_unit_discount.unit_id,
            code: discount.code,
            remarks: discount.remarks,
            response_type: 1
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if(response.data){
                    if (response.data.code) {
                        self.add_discount_error.code = response.data.code[0];
                    } else {
                        self.SSAlertService.parseAndDisplayError(response);
                    }
                }
                if(response.message && type === 'manual'){
                    self.popup_reserve_price_error = response.message;
                }else if(response.message && type === 'auto'){
                    self.auto_apply_reserve_price_error = response.message;
                }

                return;
            }
            self.hideDiscountModal();

            if (response.data.eoi_discounts) {
                $.each(response.data.eoi_discounts, function (i, eoiDiscount) {
                    if (!(self.selectedEoi.eoi_discounts)
                        || !(self.selectedEoi.eoi_discounts.find(x => x.id === eoiDiscount.id))
                    ) {
                        self.selectedEoi.eoi_discounts.push(eoiDiscount);
                    }
                });
            }

            self.linkEoiDiscountsWithPropertyDiscounts();
            self.prepareEoiUnitAppliedDiscounts();
            self.calculateUnitSalePrice(self.selected_unit_discount);
        });
    }

    hideDiscountModal() {
        const self = this;

        self.displayDiscountModal = false;
        let m = $('#allEoisDiscountModal');
        if (m.is(':visible')) m.modal('hide');
    }

    validateDiscount(discount) {
        const self = this;

        self.add_discount_error = {};
        self.popup_reserve_price_error = null;
        let isValid = true;

        //if (!self.add_discount || _.isEmpty(self.add_discount)) {
        //    self.add_discount_error.discount = "Please select discount."
        //    isValid = false;
        //}

        if (!discount || !discount.id) {
            self.add_discount_error.type = "Please select discount."
            isValid = false;
        } else {
            if (!discount.code) {
                if (discount.type === self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE
                    || discount.type === self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE
                    || discount.type === self.DISCOUNT_TYPE_PROMO_CODE_OTHER
                    || discount.type === self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL
                ) {
                    self.add_discount_error.code = "Please enter discount code.";
                    isValid = false;
                } else if (discount.type === self.DISCOUNT_TYPE_STAFF) {
                    self.add_discount_error.code = "Please enter Staff ID.";
                    isValid = false;
                }
            }
        }

        // if (self.add_discount.type === self.DISCOUNT_TYPE_STAFF) {
        //   if (!self.add_discount.remarks || self.add_discount.remarks == "" || self.add_discount.remarks == null) {
        //     self.add_discount_error.remarks = "Please enter Staff ID";
        //     return false;
        //   }
        // }

        return isValid;
    }

    showDiscountModal(eoiUnit) {
        const self = this;

        self.selected_unit_discount = eoiUnit;

        self.add_discount_error = {};
        self.add_discount = {};
        self.popup_reserve_price_error = null;
        self.selected_discount = null;

        self.availablePropertyDiscounts = [];
        $.each(self.property_discounts, function (index, propertyDiscount) {
            if (!(self.SSEoiDiscountsService.isActiveDiscount(propertyDiscount))) return; // Skip if not active
            if (propertyDiscount.marketing_scheme && propertyDiscount.marketing_scheme !== self.selectedEoi.marketing_scheme) return; // Skip if different Marketing Scheme
            if (!(self.SSEoiDiscountsService.isDiscountApplicable(eoiUnit.unit_id, propertyDiscount))) return; // Skip. This will only apply to assigned units
            if (eoiUnit.applied_discounts.find(x => x.property_discount_id === propertyDiscount.id)) return; // Skip if its already applied

            self.availablePropertyDiscounts.push(propertyDiscount);
        });

        self.displayDiscountModal = true;
        let m = $('#allEoisDiscountModal');
        if (!(m.is(':visible'))) m.modal('show');
    }

    calculateUnitSalePrices() {
        const self = this;

        if (!(self.selectedEoi
            && self.selectedEoi.eoi_units
            && self.selectedEoi.eoi_discounts
            && self.property_discounts
        )) {
            return; // Skip, missing data
        }

        $.each(self.selectedEoi.eoi_units, function (i, eoiUnit) {
            self.calculateUnitSalePrice(eoiUnit);
        });
    }

    calculateUnitSalePrice(eoiUnit) {
        const self = this;

        let totalDiscount = 0;

        if (eoiUnit.applied_discounts) {
            $.each(eoiUnit.applied_discounts, function (index, eoiDiscount) {
                if (eoiDiscount.property_discount
                    && !(self.isDiscountType1(eoiDiscount.property_discount.type))
                ) {
                    return; // Ignore, Type 2 discount that should not be subtracted from sale price
                }
                totalDiscount += eoiDiscount.discounted_amount;
            });
        }

        eoiUnit.final_discount = totalDiscount; // Math.round(totalDiscount);
        eoiUnit.final_sale_price = eoiUnit.price - eoiUnit.final_discount; // Math.max(eoiUnit.price - eoiUnit.final_discount, 0);
    }

    getTotalDiscountedAmount(eoiUnit, type1Only=false) {
        const self = this;

        let totalDiscount = 0;
        if (eoiUnit.applied_discounts) {
            $.each(eoiUnit.applied_discounts, function (index, eoiDiscount) {
                if (type1Only
                    && !(eoiDiscount.property_discount
                        && self.isDiscountType1(eoiDiscount.property_discount.type))
                ) {
                    return; // Ignore
                }
                totalDiscount += (eoiDiscount.discounted_amount ? eoiDiscount.discounted_amount : 0);
            });
        }
        return totalDiscount;
    }

    // Checks the discount type whether it will affect the price or not
    isDiscountType1(type) {
        const self = this;

        return type === self.DISCOUNT_TYPE_STANDARD ||
            type === self.DISCOUNT_TYPE_STAFF ||
            type === self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE ||
            type === self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE ||
            type === self.DISCOUNT_TYPE_PROMO_CODE_OTHER ||
            type === self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL;
    }

    removeUsedDiscount(discount) {
        const self = this;

        self.property_discounts = self.property_discounts.filter(x => x.id !== discount.id);
    }

    /**
     * Review button: check the EOI's current risk assessment with the server, then
     * open the Review screen.
     *
     * @param {Object}  eoi    EOI row of the listing.
     * @param {boolean} mode   Review mode flag (AML_RISK_ASSESSMENT_MODE).
     * @param {number}  index  Row index, to scroll back to on close.
     * @returns {void}
     * @remarks WEB-4686 (server: WEB-4679). Several users review EOIs at once and the
     *          listing only knew its own changes, so an EOI another user had already
     *          assessed still looked pending. `GET sec/eois/{id}/aml-risk-assessment-status`
     *          returns the current assessment with who / when:
     *          - assessed (or re-assessed) since this listing was loaded, by someone
     *            else → the row is updated and the user told who did it; the Review
     *            screen is not opened, unless the server flags the data as modified
     *            since (a re-review is then legitimately needed);
     *          - assessed by the current user (another tab) → row updated silently;
     *          - `412001` (EOI back in Draft / no longer reviewable) → message only;
     *          - nothing newer, or the check itself failed (e.g. the endpoint is not
     *            on this environment yet) → Review opens as before, never blocked.
     */
    amlRiskAssessment(eoi, mode, index) {
        const self = this;

        self.SSAlertService.clear();

        loading(true);
        self.SSHttpService.getAPIRequest('sec/eois/' + eoi.id + '/aml-risk-assessment-status').then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.sub_code == 412001) {
                    self.SSAlertService.warning(
                        'EOI not available',
                        'This EOI is no longer available for review — it may have been returned for amendments. Please refresh the page.'
                    );
                    return;
                }
                self.openAmlReview(eoi, mode, index);
                return;
            }

            if (self.applyLatestRiskAssessment(eoi, response.data)) {
                self.openAmlReview(eoi, mode, index);
            }
        });
    }

    /**
     * Bring an EOI row in line with the server's current risk assessment.
     *
     * @param {Object} eoi     EOI row of the listing.
     * @param {Object} status  `aml-risk-assessment-status` response data:
     *                         { eoi_status, aml_risk_assessment: { is_done, level, remarks,
     *                         reviewed_by {id, display_name}, reviewed_at, is_data_modified } }.
     * @returns {boolean} True when the Review screen should open.
     */
    applyLatestRiskAssessment(eoi, status) {
        const self = this;

        const assessment = status && status.aml_risk_assessment ? status.aml_risk_assessment : null;
        const rows = self.getEoiRows(eoi);

        if (status && status.eoi_status && status.eoi_status != eoi.status) {
            $.each(rows, function (i, row) {
                row.status = status.eoi_status;
            });
        }

        if (!(assessment && assessment.is_done)) {
            return true;
        }

        const reviewed_at = moment.utc(assessment.reviewed_at);
        const shown_at = eoi.risk_assessment_updated_at ? moment.utc(eoi.risk_assessment_updated_at) : null;
        const is_newer = !eoi.risk_assessment_level
            || eoi.risk_assessment_level !== assessment.level
            || !(shown_at && shown_at.isValid())
            || (reviewed_at.isValid() && reviewed_at.isAfter(shown_at));

        if (!is_newer) {
            return true;
        }

        $.each(rows, function (i, row) {
            row.risk_assessment_level = assessment.level;
            row.risk_assessment_remarks = assessment.remarks;
            row.aml_scans_modified = !!assessment.is_data_modified;
            row.risk_assessment_updated_at = assessment.reviewed_at;
        });

        const me = self.SSUserService.getUser();
        const reviewer = assessment.reviewed_by;
        if (reviewer && me && reviewer.id == me.id) {
            return true;
        }

        const message = 'Risk assessment already completed by '
            + (reviewer && reviewer.display_name ? reviewer.display_name : 'another user')
            + ' on ' + self.SSUtilService.formatLocalDateTime(assessment.reviewed_at) + '.';

        if (assessment.is_data_modified) {
            self.SSAlertService.warning(
                'Risk assessment updated',
                message + ' The AML data has changed since, so the EOI can be reviewed again.'
            );
            return true;
        }

        self.SSAlertService.warning('Already assessed', message);
        return false;
    }

    /**
     * Every copy of an EOI row the page holds (the shown row and its master copy).
     *
     * @param {Object} eoi
     * @returns {Array<Object>}
     */
    getEoiRows(eoi) {
        const self = this;

        const rows = [eoi];
        $.each(self.allEoisMaster || [], function (i, row) {
            if (row.id == eoi.id && row !== eoi) {
                rows.push(row);
            }
        });

        return rows;
    }

    /**
     * Open the Review screen of an EOI (documents, AML risk assessment, return).
     *
     * @param {Object}  eoi
     * @param {boolean} mode
     * @param {number}  index
     * @returns {void}
     * @remarks WEB-4686: the former body of amlRiskAssessment(), unchanged; it now runs
     *          after the latest-status check.
     */
    openAmlReview(eoi, mode, index) {
        const self = this;

        let url = 'sec/eois/' + eoi.id;
        let params = {
            include: 'buyers, non_buyer_payees,beneficiaries,documents,buyers.documents,buyers.individual,buyers.company,non_buyer_payees.individual,non_buyer_payees.company,non_buyer_payees.documents,instruments,witnesses,witnesses.individual'
        };

        self.risk_assessment_eoi = angular.copy(eoi);
        self.eoi_for_local_update = eoi;

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.eoi) {
                self.current_eoi = angular.copy(response.data.eoi);

                self.scroll_index = index;
                self.aml_eoi = angular.copy(eoi);

                self.AML_RISK_ASSESSMENT_MODE = mode;

                if (self.current_eoi.beneficiaries) {
                    self.processDocuments(self.current_eoi.beneficiaries, self.current_eoi.documents, 'beneficiary');
                }

                self.sale = {
                    buyers: self.current_eoi.buyers,
                    beneficiaries: self.current_eoi.beneficiaries,
                    non_buyer_payees: self.current_eoi.non_buyer_payees,
                    witnesses: self.current_eoi.witnesses,
                    instruments: [],
                    other_documents: [],
                    supporting_documents: [],
                    agency_documents: [] // WEB-4687
                };

                /** WEB-2937 Corporate Sale - Support for Multiple Signatories **/
                self.SSEoiService.buyers = self.sale.buyers || null;
                self.SSEoiService.nonBuyerPayees = self.sale.non_buyer_payees || null;

                self.processBuyerDocuments(self.sale.buyers);

                if (self.sale.non_buyer_payees) {
                    // self.processDocuments(self.current_eoi.non_buyer_payees, self.current_eoi.non_buyer_payees.documents, 'non_buyer_payee');
                    self.processBuyerDocuments(self.sale.non_buyer_payees);
                }
                // if(self.current_eoi.buyers){
                //     self.processDocuments(self.current_eoi.buyers, self.current_eoi.buyers.documents, 'buyer');
                // }

                self.sale.other_documents.push({title: 'Buyer Particulars', url: self.getPPFormUrl(eoi)});

                // $.each(eoi.aml_scans, function(i, aml){
                //     self.sale.other_documents.push(aml);
                // });

                if (self.current_eoi.documents) {
                    $.each(self.current_eoi.documents, function (i, document) {
                        /** WEB-4687 Agency documents the agency shared with the developer (WEB-4682).
                         * The server only returns shared ones to a developer; list them in their own
                         * "Agency Documents" card instead of Supporting Documents / the bottom bar. **/
                        if (document.is_agency_document) {
                            document.model = self.ASSET_MODEL_EOI_DOCUMENT;
                            document.title = document.name ? document.name : '';
                            self.sale.agency_documents.push(document);
                            return;
                        }

                        if (document.format == self.PROPERTY_DOCUMENT_FORMAT_PDF) {

                            if (document.document_kind == self.PROPERTY_DOCUMENT_KIND_OTHER) {
                                document.model = self.ASSET_MODEL_EOI_DOCUMENT;
                                document.title = "Supporting Document - " + (document.name ? document.name : '');
                            } else {
                                document.model = self.ASSET_MODEL_EOI_DOCUMENT;
                                document.title = document.name ? document.name : '';
                            }

                            /** WEB-2866 DMS: All EOIS - Review Documents Issue
                             * Need to only show document if it has file uri **/
                            if(document.file_uri){
                                self.sale.other_documents.push(document);
                            }
                        } else {
                            self.getPresignedUrl(
                                self.ASSET_MODEL_EOI_DOCUMENT,
                                document.id,
                                function (presignedUrl) {
                                    if (presignedUrl) {
                                        document.show_file_url = presignedUrl;
                                    }
                                }
                            );
                            document.model = self.ASSET_MODEL_EOI_DOCUMENT;
                            self.sale.supporting_documents.push(document);
                        }
                    });
                }

                if(self.current_eoi.instruments && self.current_eoi.instruments.length){
                    $.each(self.current_eoi.instruments, function (i, instrument) {
                        if (instrument.cheque_date) {
                            instrument.cheque_date = moment(self.parseDate(instrument.cheque_date))
                                    .format("YYYY-MM-DD");
                        }

                        if (instrument.bank_in_date) {
                            instrument.bank_in_date = moment(self.parseDate(instrument.bank_in_date))
                                    .format("YYYY-MM-DD");
                        }

                        if (instrument.file_uri) {
                            self.getPresignedUrl(
                                self.ASSET_MODEL_EOI_INSTRUMENT,
                                instrument.id,
                                function (presignedUrl) {
                                    if (presignedUrl) {
                                        instrument.show_file_url = presignedUrl;
                                    }
                                }
                            )
                        }

                        if (instrument.type === self.INSTRUMENT_TYPE_CHEQUE && !instrument.file_uri) {
                            self.payment_missing_document = true;
                        }
                        self.sale.instruments.push(instrument);
                    });
                }

                /** WEB-2901 FATF Black List - Indications **/
                self.checkBuyersAgainstFatfList();

                self.$timeout(function () {
                    self.changeDisplayDoc(self.sale.other_documents[0]);

                    $(".zoom").magnify();

                }, 1000);
            }

        });
    }

    removeDiscount(eoiDiscount, eoiUnit) {
        const self = this;

        if (eoiDiscount.type === self.DISCOUNT_TYPE_STANDARD) {
            self.SSAlertService.danger("Error.", "Unable to remove Standard Discount from this sale.");
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to remove the applied discount?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/eois/' + self.selectedEoi.id + '/discounts/' + eoiDiscount.property_discount_id + '/delete';
                let params = {
                    unit_id: eoiUnit.unit_id
                };

                loading(true);
                self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    self.selectedEoi.eoi_discounts = self.selectedEoi.eoi_discounts.filter(x => x.id !== eoiDiscount.id);
                    eoiUnit.applied_discounts = eoiUnit.applied_discounts.filter(x => x.id !== eoiDiscount.id);

                    self.calculateUnitSalePrice(eoiUnit);
                });
            });
    }

    cancelAddDiscount(mode = false) {
        const self = this;

        self.EOI_DISCOUNTS_MODE = mode;

        try {
            window.location.href = "#scroll_" + self.scroll_index;
        } catch (e) {
            console.log(e);
        }
    }

    cancelAmlRiskAssessment(mode = false) {
        const self = this;

        self.AML_RISK_ASSESSMENT_MODE = mode;

        try {
            window.location.href = "#scroll_" + self.scroll_index;
        } catch (e) {
            console.log(e);
        }
    }

    processBuyerDocuments(buyers) {
        const self = this;

        //Process documents
        $.each(buyers, function (i, buyer) {
            let documents = angular.copy(buyer.documents);
            buyer.documents = null;

            let url = 'sec/assets/presigned-url';
            let params = null;

            let temp_buyer = buyer;

            $.each(documents, function (j, buyer_document) {

                //prepare preview document
                if (buyer_document.file_uri
                    && buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_USER_DOC
                    && buyer_document.document_kind != self.PROPERTY_DOCUMENT_KIND_OTHER
                    && temp_buyer
                ) {
                    // Buyer IC/Passport etc.
                    url = 'sec/assets/presigned-url';
                    params = {
                        'model': self.ASSET_MODEL_BUYER_DOCUMENT,
                        'id': buyer_document.id
                    };
                    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                        if (response instanceof Error) {
                            loading(false);
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }

                        buyer_document["show_file_url"] = response.data.presigned_url;
                        buyer_document.model = self.ASSET_MODEL_BUYER_DOCUMENT;

                        self.$timeout(function () {
                            $(".zoom").magnify();
                        }, 2000);

                    });
                } else {
                    buyer_document["show_file_url"] = "";
                }

                if (temp_buyer) {
                    if (!temp_buyer.documents) temp_buyer.documents = {};

                    temp_buyer.documents[buyer_document.document_kind] = buyer_document;
                }

            });

        });
    }

    processDocuments(buyers, documents, buyer_type) {
        const self = this;

        //Process documents
        $.each(buyers, function (i, buyer) {

            let url = 'sec/assets/presigned-url';
            let params = null;

            $.each(documents, function (j, buyer_document) {
                //prepare preview document
                if (buyer_document.file_uri
                    && buyer_document[buyer_type + '_id'] == buyer.id
                    && buyer_document.format == self.PROPERTY_DOCUMENT_FORMAT_IMG
                ) {
                    // Buyer IC/Passport etc.
                    url = 'sec/assets/presigned-url';
                    params = {
                        'model': buyer_type == 'beneficiary' ? self.ASSET_MODEL_EOI_DOCUMENT : self.ASSET_MODEL_BUYER_DOCUMENT,
                        'id': buyer_document.id
                    };
                    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                        if (response instanceof Error) {
                            loading(false);
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }

                        buyer_document["show_file_url"] = response.data.presigned_url;
                        buyer_document.model = buyer_type == 'beneficiary' ? self.ASSET_MODEL_EOI_DOCUMENT : self.ASSET_MODEL_BUYER_DOCUMENT;

                        self.$timeout(function () {
                            $(".zoom").magnify();
                        }, 2000);

                    });
                }

                if (buyer) {
                    if (!buyer.documents) buyer.documents = {};
                    buyer.documents[buyer_document.document_kind] = buyer_document;
                }
            });
        });
    }

    downloadPic(file_obj, model_type) {
        const self = this;

        model_type = model_type ? model_type : file_obj.model;

        //Retrieve new pre-signed url to avoid timeout issue from S3
        let url = 'sec/assets/presigned-url';
        let params = {
            'model': model_type,
            'id': file_obj.id
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            window.open(response.data.presigned_url, '_blank');
        });
    }

    changeDisplayDoc(other_document) {
        const self = this;

        if (!other_document)
            return;

        $('#document_container').empty();

        if (!other_document.title) other_document.title = other_document.name;

        self.display_doc = other_document;

        if (!other_document.id) {
            $('#document_container').html('<iframe style="width:100%; height:100%;" src="' + other_document.url + '"></iframe>');
        } else {
            let url = 'sec/assets/presigned-url';
            let params = {
                'model': other_document.model,
                'id': other_document.id
            };

            loading(true);
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    // self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                if (response.data.presigned_url)
                    $('#document_container').html('<iframe style="width:100%; height:100%;" src="' + response.data.presigned_url + '"></iframe>');
            });
        }

    }

    _amlRiskAssessment(eoi) {
        const self = this;

        if (!eoi) return;
        if (!(eoi.status == self.EOI_STATUS_SUBMITTED
            || eoi.status == self.EOI_STATUS_VERIFIED
            || eoi.status == self.EOI_STATUS_REGISTERED
        )) {
            self.SSAlertService.warning("Error!", "AML Risk Assessment is only allowed before unit allocation or during sale review/approve.");
            return;
        }

        self.aml_assessment = {};
        self.aml_assessment_errors = {};

        if (eoi.question_answers) {
            if (eoi.risk_assessment_level) {
                self.aml_assessment.risk_value = eoi.risk_assessment_level;
            }
            if (eoi.risk_assessment_remarks) {
                self.aml_assessment.remarks = eoi.risk_assessment_remarks;
            }
        }

        /** WEB-2900 AML Scan: GuocoLand Feedback
         * Need to show default remarks pattern if not already given **/
        if(!self.aml_assessment.remarks){
            self.aml_assessment.remarks = self.getDefaultTxtForAmlRemarks();
        }

        // self.risk_assessment_eoi = angular.copy(eoi);
        // self.eoi_for_local_update = eoi;

        $('#modelAmlRiskAssessment').modal('show');
    }

    nextPage() {
        const self = this;

        var totalPages = Math.ceil(Object.keys(self.sale.other_documents).length / self.pageSize);
        if (self.currentPage < totalPages) {
            self.currentPage++;
        }
    };

    previousPage() {
        const self = this;

        if (self.currentPage > 1) {
            self.currentPage--;
        }
    };

    getCurrentDocument() {
        const self = this;

        if (!self.sale) return;

        var startIndex = (self.currentPage - 1) * self.pageSize;
        var endIndex = startIndex + self.pageSize;

        if (self.sale.other_documents) {
            return Object.values(self.sale.other_documents).slice(startIndex, endIndex);
        }

        return [];
    }

    hasMoreDocuments() {
        const self = this;

        if (!(self.sale && self.sale.other_documents)) return;

        return self.currentPage < Math.ceil(Object.keys(self.sale.other_documents).length / self.pageSize);
    };

    updateRiskAssessment() {
        const self = this;

        let url = "sec/eois/" + self.risk_assessment_eoi.id + "/questions-answers/developer";

        if (!self.isValidAmlRiskInput()) return;

        let answers = {};
        $.each(self.questions, function (i, question) {
            if (self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL)) {
                answers[question.id] = self.aml_assessment.risk_value;
            }
            if (self.SSUtilService.compareQuestionMarker(question.marker, self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS)) {
                answers[question.id] = self.aml_assessment.remarks;
            }
        });

        let params = {question_answers: JSON.stringify(answers)};

        $('#modelAmlRiskAssessment').modal('hide');

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            // Refresh eoi data
            // self.getEoiPhase(true);

            self.eoi_for_local_update.risk_assessment_level = self.aml_assessment.risk_value;
            self.eoi_for_local_update.risk_assessment_remarks = self.aml_assessment.remarks;

            if(response.data && response.data.eoi_question_answers){
                $.each(self.allEoisMaster, function (i, _eoi) {
                    if (self.eoi_for_local_update.id == _eoi.id) {
                        _eoi.question_answers = response.data.eoi_question_answers;
                        self.parseEoi(_eoi);
                    }
                });
            }

            self.AML_RISK_ASSESSMENT_MODE = false;

            self.SSAlertService.success('Success!', 'EOI updated successfully.');

            self.$timeout(function () {
                try {
                    window.location.href = "#scroll_" + self.scroll_index;
                } catch (e) {
                    console.log(e);
                }
            }, 1000);
        });
    }

    isValidAmlRiskInput() {
        const self = this;

        let isValid = true;

        self.aml_assessment_errors = {};

        if (!self.aml_assessment.risk_value) {
            self.aml_assessment_errors.risk_value = "Please select risk assessment level.";
            isValid = false;
        }
        let remarksMaxLength = self.SSConfigService.getAmlRiskAssessmentRemarksMaxLength();

        if (!self.aml_assessment.remarks || (self.aml_assessment.remarks && !self.aml_assessment.remarks.trim())) {
            self.aml_assessment_errors.remarks = "Remarks are required.";
            isValid = false;
        } else if (self.aml_assessment.remarks && self.aml_assessment.remarks.length > remarksMaxLength) {
            self.aml_assessment_errors.remarks = "Only " + remarksMaxLength + " characters are allowed for remarks.";
            isValid = false;
        }

        return isValid;
    }

    getPresignedUrl(model, id, callback) {
        const self = this;

        let url = 'sec/assets/presigned-url';
        let params = {
            'model': model,
            'id': id,
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (callback) {
                callback(response.data.presigned_url);
            }
        });
    }

    filterAMLPositiveCases() {
        const self = this;

        self.amlPositiveCases = event.target.checked;
        self.applySearch();
    }

    filterCDDacknowledgement(){
        const self = this;

        self.filter_cdd_acknowledgement = event.target.checked;
        self.applySearch();
    }

    isAssignUnitButtonVisible(eoi) {
        const self = this;

        return eoi.status !== self.EOI_STATUS_COMPLETED
            && self.SSUserService.hasPermissionForProperty('DMS_EOI_ASSIGN_UNIT', eoi.property_id);
    }

    updateUnit(eoi) {
        const self = this;

        if (eoi.status == self.EOI_STATUS_SUBMITTED
                && (!self.allow_unit_allocation_for_submitted_eois
                || !self.allow_unit_allocation_for_submitted_eois.enabled)) {
            // Show message that unit can be assigned for verified status
            self.SSConfirmationService.getConfirmed(
                'Warning!',
                'EOI is not Verified yet. Please request Team IC to review and verify the EOI.',
                self.SSConfirmationService.TYPE_OK,
                function (confirmationStatus) {
                    return;
                }
            );
            return;
        }

        if (self.amlSettings && self.amlSettings.value) {
            if (self.amlSettings.value.risk_assessment_required
                && !(eoi.risk_assessment_level && eoi.risk_assessment_remarks)) {
                // Show warning to complete risk assessment
                self.SSConfirmationService.getConfirmed(
                    'Warning!',
                    'Risk Assessment is required before unit allocation.',
                    self.SSConfirmationService.TYPE_OK,
                    function (confirmationStatus) {
                        return;
                    }
                );
                return;
            }
        }

        self.update_unit_error = null;
        self.payment_plan_error = null;
        self.popup_reserve_price_error = null;
        self.block_field_error = null;
        self.selected_unit_price = null;
        self.selected_unit_status_name = null;
        self.selected_unit_status_color = null;
        self.update_unit_blocks = [];
        self.selected_unit_block = null;
        self.block_field_disabled = false;

        // WEB-3643 — reset any prior customise state when (re)opening the Assign Unit popup.
        self.customise_payment_plan = false;
        self.customise_plan_obj = null;
        self.edit_percentage = false;
        self.changed_percentage = false;
        self.temp_payment_plan_clauses = null;
        self.payment_clause_error = "";

        self.eoi_update = angular.copy(eoi);
        self.update_unit_no = self.getUnitName(eoi.unit_id, false);
        // WEB-3665 — seed the Block/Tower field; pre-select the unit already linked to this EOI.
        self.refreshUnitBlocks(eoi.unit_id);

        // WEB-3643 — the picker offers base plans PLUS the EOI's currently-linked plan (which may be a
        // hidden customised copy), so re-opening shows the actual linked plan instead of resetting to
        // the first/default option. Only base plans are otherwise selectable.
        self.popup_payment_plans = (self.payment_plans || []).slice();
        let linkedPlan = self.getPaymentPlan(eoi);
        if (linkedPlan && !self.popup_payment_plans.find(p => p.id == linkedPlan.id)) {
            self.popup_payment_plans.push(linkedPlan);
        }
        self.selected_payment_plan = linkedPlan
            ? self.popup_payment_plans.find(p => p.id == linkedPlan.id)
            : self.getDefaultPaymentPlan(eoi);

        self.getUpdatedPrice();

        $('#updateUnitModal').modal('show');
    }

    isMarketingSchemeButtonVisible(eoi) {
        const self = this;

        return (eoi.status !== self.EOI_STATUS_REJECTED
                && eoi.status !== self.EOI_STATUS_UNSUCCESSFUL
                && eoi.status !== self.EOI_STATUS_COMPLETED)
            && self.SSUserService.hasPermissionForProperty('DMS_EOI_MARKETING_SCHEME_UPDATE', eoi.property_id);
    }

    showMarketingSchemeModel(eoi) {
        const self = this;

        // WEB-3655 — must NOT reuse self.selectedEoi: that property belongs to the EOI Discounts
        // screen, which needs an EOI whose eoi_units carry a hydrated .unit (see getEoi()). List
        // EOIs are loaded without the units/stacks includes, so assigning one here left the
        // discounts partial binding eoiUnit.unit.* on rows that have no unit.
        self.marketingSchemeEoi = eoi;
        self.eoiParams = angular.copy(self.marketingSchemeEoi);

        $('#modelEoiMarketingScheme').modal('show');
    }

    updateMarketingScheme() {
        const self = this;

        let url = 'sec/eois/' + self.eoiParams.id + '/marketing-scheme';
        let params = {
            marketing_scheme: self.eoiParams.marketing_scheme
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            $('#modelEoiMarketingScheme').modal('hide');

            let _eoi = response.data.eoi;
            self.marketingSchemeEoi.marketing_scheme = _eoi.marketing_scheme;
            self.marketingSchemeEoi.marketing_scheme_name = self.getMarketingSchemeName(self.marketingSchemeEoi.marketing_scheme);
            // WEB-3643 — keep the short code in sync so the list reflects the change without a refresh.
            self.marketingSchemeEoi.marketing_scheme_code = self.getMarketingSchemeCode(self.marketingSchemeEoi.marketing_scheme);

            $.each(self.allEoisMaster, function (i, _eoi) {
                if (self.eoiParams.id === _eoi.id) {
                    _eoi.marketing_scheme = self.marketingSchemeEoi.marketing_scheme;
                    _eoi.marketing_scheme_name = self.marketingSchemeEoi.marketing_scheme_name;
                    _eoi.marketing_scheme_code = self.marketingSchemeEoi.marketing_scheme_code;
                }
            });

            self.SSAlertService.success('Success!', 'Marketing Scheme updated successfully.');
        });
    }

    getMarketingSchemeName(id) {
        const self = this;
        let name = null;

        $.each(self.MARKETING_SCHEMES, function (i, marketingScheme) {
            if (marketingScheme.id == id) {
                name = marketingScheme.name;
                return false;
            }
        });

        return name;
    }

    /**
     * Short code for a marketing scheme (WEB-3643) — shown in the EOI list to save column width;
     * falls back to the full name if no code is mapped.
     * @param {number} id - Marketing scheme id.
     * @returns {string|null}
     */
    getMarketingSchemeCode(id) {
        const self = this;
        let scheme = self.MARKETING_SCHEMES.find(x => x.id == id);
        if (!scheme) {
            return null;
        }
        return scheme.code ? scheme.code : scheme.name;
    }

    proceedUpdateUnit() {
        const self = this;

        if (!self.isValidUnitInput()) return;

        // WEB-3643 — block if clause edits are still open (unsaved) in the customise sub-view.
        if (!self.verifyPaymentPlan()) {
            self.customise_payment_plan = true;
            return;
        }

        // WEB-3665 — honour the selected Block/Tower when the code spans multiple blocks.
        let unit = self.resolveUpdateUnit();
        if (!unit) return;

        // WEB-3643 — PVT plan with saved customisation → duplicate the BASE plan into a
        // booking-specific copy, then assign the unit with the copy id (mirrors AMS Team-IC).
        if (self.changed_percentage
            && self.selected_payment_plan
            && self.selected_payment_plan.type == self.PAYMENT_PLAN_TYPE_PVT
            && self.customise_plan_obj) {

            let payment_plan_clauses = {};
            let payment_plan_clauses_rules = {};
            $.each(self.customise_plan_obj.payment_plan_clauses, function (index, payment_plan_clause) {
                payment_plan_clauses[payment_plan_clause.id] = payment_plan_clause.amount_percentage;
                $.each(payment_plan_clause.rules, function (rules_index, rule) {
                    payment_plan_clauses_rules[rule.id] = {
                        'start_from': rule.start_from,
                        'billing_days': rule.billing_days
                    };
                });
            });

            // Always pass the BASE plan id so the server replicates rather than editing in place.
            let url = 'sec/developer/payment-plans/' + self.selected_payment_plan.id + '/customize';
            let params = {
                payment_plan_clauses: JSON.stringify(payment_plan_clauses),
                payment_plan_clauses_rules: JSON.stringify(payment_plan_clauses_rules),
            };

            loading(true);
            self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                if (response instanceof Error) {
                    loading(false);
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                let copy = response.data.payment_plan;
                // WEB-3643 — register the new copy in the unfiltered linked set so the list row
                // resolves and displays it immediately after assigning (it's hidden from the picker list).
                if (copy) {
                    let existingIdx = self.eoi_linked_payment_plans.findIndex(p => p.id == copy.id);
                    if (existingIdx > -1) {
                        self.eoi_linked_payment_plans[existingIdx] = copy;
                    } else {
                        self.eoi_linked_payment_plans.push(copy);
                    }
                }
                self._assignUnit(unit, copy.id);
            });
            return;
        }

        // No customisation → assign the selected base plan id directly (existing behaviour).
        self._assignUnit(unit, self.selected_payment_plan.id);
    }

    /**
     * Assign the unit to the EOI with the given payment plan id (WEB-3643 — extracted from
     * proceedUpdateUnit so a customised copy id can be substituted before assigning).
     *
     * @param {object} unit - The unit being assigned.
     * @param {number} paymentPlanId - Base plan id, or a freshly-customised copy id.
     * @returns {void}
     */
    _assignUnit(unit, paymentPlanId) {
        const self = this;

        let url = 'sec/eois/' + self.eoi_update.id + '/assign-units';

        let current_unit = {'unit_id': unit.id, 'payment_plan_id': paymentPlanId};
        self.popup_reserve_price_error = null;
        if (!self.eoi_update.eoi_units) self.eoi_update.eoi_units = [];
        self.eoi_update.eoi_units.push(current_unit);

        let params = {
            include: 'eoi_units, eoi_discounts',
            eoi_units: JSON.stringify(self.eoi_update.eoi_units)
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                // self.SSAlertService.parseAndDisplayError(response);
                //just for this API showing message from data
                if (response.data && response.data.eoi_units && response.data.eoi_units.length > 0) {
                    self.update_unit_error = response.data.eoi_units[0];
                }
                self.eoi_update.eoi_units.pop();

                if(response.message){
                    self.popup_reserve_price_error = response.message;
                }
                return;
            }

            if (response.data.eoi) {
                // self.updateEoiUnit(self.eoi_update.id, unit);
                $('#updateUnitModal').modal('hide');
                let eoi = response.data.eoi;

                $.each(self.allEoisMaster, function (i, _eoi) {
                    if (eoi.id == _eoi.id) {
                        _eoi.status = eoi.status;
                        _eoi.unit_id = unit.id;
                        _eoi.eoi_units = eoi.eoi_units;
                        self.parseEoi(_eoi);
                    }
                });

                self.allEoisByPhase = angular.copy(self.allEoisMaster);
                self.applySearch();

                // WEB-3643 — clear customise state after a successful allocation.
                self.customise_payment_plan = false;
                self.customise_plan_obj = null;
                self.edit_percentage = false;
                self.changed_percentage = false;
                self.temp_payment_plan_clauses = null;
                self.payment_clause_error = "";

                self.SSConfirmationService.getConfirmed(
                    'Success!',
                    'EOI updated successfully.',
                    self.SSConfirmationService.TYPE_OK,
                    function (confirmationStatus) {

                    }
                );
            }
            if (response.message) {
                self.SSAlertService.warning("Warning!", response.message);
            }
        });
    }

    /**
     * Payment-plan dropdown change handler (WEB-3643). Discards any in-progress customisation
     * for the previous plan, then refreshes the unit price.
     * @returns {void}
     */
    onChangePaymentPlan() {
        const self = this;

        self.customise_payment_plan = false;
        self.customise_plan_obj = null;
        self.edit_percentage = false;
        self.changed_percentage = false;
        self.temp_payment_plan_clauses = null;
        self.payment_clause_error = "";

        self.getUpdatedPrice();
    }

    /**
     * Show the inline clause/rule editor for the selected PVT base plan (deep copy so edits never
     * mutate the cached plan in self.payment_plans).
     * @returns {void}
     */
    openCustomisePaymentPlan() {
        const self = this;

        if (!self.selected_payment_plan || self.selected_payment_plan.type != self.PAYMENT_PLAN_TYPE_PVT) {
            return;
        }

        if (!self.customise_plan_obj) {
            self.customise_plan_obj = angular.copy(self.selected_payment_plan);
        }
        self.edit_percentage = false;
        self.payment_clause_error = "";
        self.customise_payment_plan = true;
    }

    /**
     * Enter clause %/rule edit mode, snapshotting the clauses for cancel.
     * @returns {void}
     */
    editPaymentClausePercentage() {
        const self = this;

        if (!self.customise_plan_obj) return;

        self.payment_clause_error = "";
        self.temp_payment_plan_clauses = angular.copy(self.customise_plan_obj.payment_plan_clauses);
        self.edit_percentage = !self.edit_percentage;
    }

    /**
     * Validate and commit clause %/rule edits. Percentages must sum to 100 and every rule must
     * carry a billing-days value (mirrors AMS Team-IC / developer stack-view validation).
     * @returns {void}
     */
    savePaymentClausePercentage() {
        const self = this;

        let total_percentage = 0;
        let rule_error = false;
        self.payment_clause_error = "";

        $.each(self.customise_plan_obj.payment_plan_clauses, function (index, payment_plan_clause) {
            total_percentage += parseFloat(payment_plan_clause.amount_percentage);
            $.each(payment_plan_clause.rules, function (rules_index, rule) {
                if (!rule.billing_days) {
                    rule_error = true;
                    return false;
                }
            });
        });

        if (total_percentage != 100) {
            self.payment_clause_error = "Total of all payment plan clauses percentage must be 100%.";
            return;
        }

        if (rule_error) {
            self.payment_clause_error = "Number of days in rules cannot be empty.";
            return;
        }

        self.changed_percentage = true;
        self.edit_percentage = !self.edit_percentage;
    }

    /**
     * Discard clause %/rule edits, restoring the pre-edit snapshot.
     * @returns {void}
     */
    cancelPaymentClausePercentage() {
        const self = this;

        self.payment_clause_error = "";
        if (self.temp_payment_plan_clauses) {
            self.customise_plan_obj.payment_plan_clauses = angular.copy(self.temp_payment_plan_clauses);
        }
        self.edit_percentage = false;
    }

    /**
     * Guard against proceeding while clause edits are still open (unsaved).
     * @returns {boolean} false if edits must be saved first.
     */
    verifyPaymentPlan() {
        const self = this;

        if (self.selected_payment_plan
            && self.selected_payment_plan.type == self.PAYMENT_PLAN_TYPE_PVT
            && self.edit_percentage) {
            self.payment_clause_error = "Please save the customized payment clauses before proceed.";
            return false;
        }

        return true;
    }

    /**
     * Finish customising and return to the assign view (the saved customisation is applied on Proceed).
     * @returns {void}
     */
    doneCustomisePaymentPlan() {
        const self = this;

        if (!self.verifyPaymentPlan()) return;

        self.customise_payment_plan = false;
    }

    /**
     * Abandon the customisation and return to the assign view. Nothing is created until Proceed,
     * so no server cleanup is required.
     * @returns {void}
     */
    cancelCustomisePaymentPlan() {
        const self = this;

        self.customise_payment_plan = false;
        self.customise_plan_obj = null;
        self.edit_percentage = false;
        self.changed_percentage = false;
        self.temp_payment_plan_clauses = null;
        self.payment_clause_error = "";
    }

    /**
     * Human-readable name for a clause payment_type (for the customise table's Type column).
     * @param {number} type - Clause payment_type id.
     * @returns {string}
     */
    getPaymentClausePaymentTypeName(type) {
        const self = this;

        let name = '--';

        if (!type) {
            return name;
        }

        try {
            let payment_type = self.payment_types.find(x => x.id == type);
            if (payment_type) {
                name = payment_type.name;
            }
        } catch (ex) {
            console.log(ex);
        }

        return name;
    }

    /**
     * Money value of a clause against the selected unit price (for the customise table Value column).
     * @param {object} clause - Payment plan clause with amount_type / amount_percentage.
     * @returns {number}
     */
    calculateClauseValue(clause) {
        const self = this;

        if (!clause) return 0;

        try {
            return self.SSUtilService.calculateTypedValue(
                self.selected_unit_price_raw,
                clause.amount_type,
                clause.amount_percentage,
                2
            );
        } catch (ex) {
            console.log(ex);
            return 0;
        }
    }

    /**
     * Running total of the customise clauses' percentages (must equal 100 to save). WEB-3643.
     * @returns {number}
     */
    getCustomiseClausesTotal() {
        const self = this;

        let total = 0;
        if (self.customise_plan_obj && self.customise_plan_obj.payment_plan_clauses) {
            $.each(self.customise_plan_obj.payment_plan_clauses, function (index, clause) {
                total += parseFloat(clause.amount_percentage) || 0;
            });
        }
        // Trim floating-point noise (e.g. 99.99999) for display.
        return Math.round(total * 100) / 100;
    }

    // updateEoiUnit(eoi_id, unit){
    //     const self = this;
    //
    //     if (!eoi_id)
    //         return;
    //
    //     let url = 'sec/eois/'+eoi_id;
    //
    //     let params = {
    //         property_id: self.data.property.id,
    //         include: "eoi_units",
    //         property_launch_id: self.data.phase_id,
    //         status: self.eoiStatusesForExport
    //     };
    //
    //     loading(true);
    //     self.SSHttpService.getAPIRequest(url, params).then(function (response) {
    //         loading(false);
    //         if (response instanceof Error) {
    //             self.SSAlertService.parseAndDisplayError(response);
    //             return;
    //         }
    //
    //         $('#updateUnitModal').modal('hide');
    //         let eoi = response.data.eoi;
    //
    //         $.each(self.allEoisMaster, function(i, _eoi){
    //             if(eoi.id == _eoi.id){
    //                 _eoi.status = eoi.status;
    //                 _eoi.unit_id = unit.id;
    //                 _eoi.eoi_units = eoi.eoi_units;
    //                 self.parseEoi(_eoi);
    //             }
    //         });
    //
    //         self.allEoisByPhase = angular.copy(self.allEoisMaster);
    //         // self.applySearch();
    //
    //         self.SSConfirmationService.getConfirmed(
    //             'Success!',
    //             'EOI updated successfully.',
    //             self.SSConfirmationService.TYPE_OK,
    //             function (confirmationStatus) {
    //
    //             }
    //         );
    //     });       
    // }

    isUnAssignUnitButtonVisible(eoi, unit) {
        const self = this;

        return eoi.status !== self.EOI_STATUS_COMPLETED
            && unit.unit_id
            && unit.status !== self.EOI_SELECTED_UNIT_STATUS_COMPLETED
            && self.SSUserService.hasPermissionForProperty('DMS_EOI_ASSIGN_UNIT', eoi.property_id);
    }

    unassignUnit(eoi, unit_id) {
        const self = this;

        if (!eoi || !unit_id) {
            console.log('Invalid unit_id');
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to make this change?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (confirmationStatus, id) {
                self.OTPService.getVerified(
                    self.OTPService.TYPE_SESSION_2FA,
                    function (otpStatus, id) {
                        self._unassignUnit(eoi, unit_id);
                    }
                );
            }
        );
    }

    _unassignUnit(eoi, unit_id) {
        const self = this;

        self.updated_eoi = eoi;
        self.updated_unit_id = unit_id;

        let url = 'sec/eois/' + eoi.id + '/unassign-units';
        let params = {
            unit_ids: unit_id.toString()
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (response.data.eoi) {
                let eoi_units = $.grep(self.updated_eoi.eoi_units, function (obj) {
                    return obj.unit_id != self.updated_unit_id;
                });

                let eoi = response.data.eoi;
                $.each(self.allEoisMaster, function (i, _eoi) {
                    if (eoi.id == _eoi.id) {
                        _eoi.status = eoi.status;
                        _eoi.eoi_units = eoi_units;
                        self.parseEoi(_eoi);
                    }
                });

                self.allEoisByPhase = angular.copy(self.allEoisMaster);
                self.applySearch();

                self.SSConfirmationService.getConfirmed(
                    'Success!',
                    'EOI updated successfully.',
                    self.SSConfirmationService.TYPE_OK,
                    function (confirmationStatus) {

                    }
                );
            }
        });
    }

    getPaymentPlan(eoi) {
        const self = this;

        if (!eoi.eoi_units) return null;

        let unit = eoi.eoi_units[0];
        if (!unit) return null;

        let payment_plan = null;

        // WEB-3643/WEB-3642 — prefer the UNFILTERED linked plans the EOI list endpoint returns at
        // the response root (self.eoi_linked_payment_plans), so a per-booking customised copy
        // (is_customize=1, hidden from the selectable list) still resolves.
        if (self.eoi_linked_payment_plans && self.eoi_linked_payment_plans.length) {
            payment_plan = self.eoi_linked_payment_plans.find(x => x.id == unit.payment_plan_id);
        }

        // Fallback to the selectable list (base plans) when the payload didn't carry it.
        if (!payment_plan) {
            payment_plan = self.payment_plans.find(x => x.id == unit.payment_plan_id);
        }

        return payment_plan ? payment_plan : null;
    }

    getPaymentPlanName(eoi) {
        const self = this;

        let payment_plan = self.getPaymentPlan(eoi);

        return payment_plan ? payment_plan.name : '--';
    }

    getDefaultPaymentPlan(eoi) {
        const self = this;

        let defaultPaymentPlan = self.payment_plans.find(x => x.is_default);

        // WEB-3643/WEB-3642 — the picker only offers selectable BASE plans. Pre-select the EOI's
        // existing plan only when it's selectable; if it's a customised copy (hidden from the list),
        // keep the system default base plan instead of leaving the dropdown blank.
        if (eoi && eoi.payment_plan) {
            let linked = self.payment_plans.find(x => x.id == eoi.payment_plan.id);
            if (linked) {
                defaultPaymentPlan = linked;
            }
        }

        return defaultPaymentPlan ? defaultPaymentPlan : null;
    }

    isValidUnitInput() {
        const self = this;

        let isValid = true;

        self.update_unit_error = null;
        self.payment_plan_error = null;
        self.reserve_price_error = null;
        self.block_field_error = null;
        if (!self.update_unit_no) {
            self.update_unit_error = "Please enter unit number.";
            isValid = false;
        }
        if (!self.selected_payment_plan) {
            self.payment_plan_error = "Please select payment plan.";
            isValid = false;
        }

        if (self.update_unit_no) {
            let candidates = self.getUnitsByName(self.update_unit_no);
            if (candidates.length === 0) {
                self.update_unit_error = "Unit not found.";
                isValid = false;
            } else if (candidates.length > 1 && !self.selected_unit_block) {
                // WEB-3665 — code exists in several Blocks/Towers, so selection is mandatory.
                self.block_field_error = "Please select Block/Tower.";
                isValid = false;
            }
        }

        return isValid;
    }

    getUnitByName(unit_no) {
        const self = this;

        if (!unit_no) return null;

        // Ignore '#' in search txt
        let unit_no_txt = angular.copy(unit_no);
        if (unit_no_txt.includes('#')){
            unit_no_txt = unit_no_txt.replace('#', "");
        }
        return self.units.find(x => x.named_id == unit_no_txt);
    }

    /**
     * Returns ALL loaded units matching the given unit code (named_id). In multi-block
     * projects the same code can exist once per Block/Tower, so this may return several
     * units that differ only by their stack. WEB-3665.
     *
     * @param {string} unit_no  The typed unit code (with or without a leading '#').
     * @returns {Array}         Matching units (possibly empty).
     */
    getUnitsByName(unit_no) {
        const self = this;

        if (!unit_no || !self.units) return [];

        // Ignore '#' in search txt
        let unit_no_txt = angular.copy(unit_no);
        if (unit_no_txt.includes('#')) {
            unit_no_txt = unit_no_txt.replace('#', "");
        }
        return self.units.filter(x => x.named_id == unit_no_txt);
    }

    /**
     * Rebuild the Block/Tower candidate list for the unit code currently typed in the
     * Assign Unit popup and decide whether the Block/Tower field is a fixed (disabled)
     * value or an editable, mandatory dropdown. WEB-3665.
     *
     *  - 0 matches  : no candidates (caller surfaces "Unit not found").
     *  - 1 match    : pre-select it and disable the field (Scenarios 1 & 2).
     *  - 2+ matches : editable dropdown, mandatory selection (Scenario 3).
     *
     * @param {number|null} preferred_unit_id  Unit id to pre-select when present
     *                                         (e.g. the unit already linked to the EOI).
     * @returns {void}
     */
    refreshUnitBlocks(preferred_unit_id = null) {
        const self = this;

        let candidates = self.getUnitsByName(self.update_unit_no);
        self.update_unit_blocks = candidates;

        if (candidates.length === 0) {
            self.selected_unit_block = null;
            self.block_field_disabled = false;
            return;
        }

        if (candidates.length === 1) {
            self.selected_unit_block = candidates[0];
            self.block_field_disabled = true;
            return;
        }

        // Multiple Blocks/Towers share this unit code -> editable, mandatory selection.
        self.block_field_disabled = false;

        // Keep a valid preferred/prior selection; otherwise force the user to choose.
        let preferred = null;
        if (preferred_unit_id) {
            preferred = candidates.find(x => x.id == preferred_unit_id);
        }
        if (!preferred && self.selected_unit_block) {
            preferred = candidates.find(x => x.id == self.selected_unit_block.id);
        }
        self.selected_unit_block = preferred ? preferred : null;
    }

    /**
     * Resolve the exact unit selected in the Assign Unit popup, honouring the chosen
     * Block/Tower when the typed code is shared across multiple blocks. WEB-3665.
     *
     * @returns {Object|null}  The matching unit, or null when none match or the code is
     *                         ambiguous and no Block/Tower has been selected yet.
     */
    resolveUpdateUnit() {
        const self = this;

        let candidates = self.getUnitsByName(self.update_unit_no);

        if (candidates.length === 0) return null;
        if (candidates.length === 1) return candidates[0];

        if (self.selected_unit_block) {
            return candidates.find(x => x.id == self.selected_unit_block.id) || null;
        }

        return null;
    }

    /**
     * Colour for a unit's status in the Assign Unit popup, mirroring the Flutter app's
     * Assign Unit screen (dms_all_eois_screen_controller.dart -> getUnitStatusColor).
     * Informational only — flags a SOLD/RESERVED/BOOKED unit to the user at key-in time;
     * the server (assignUnits(), WEB-3508) remains the real gate on Proceed. WEB-3362.
     *
     * @param {number} status  A unit's raw status code.
     * @returns {string}       A hex colour.
     */
    getUnitStatusColor(status) {
        const self = this;

        switch (status) {
            case self.UNIT_STATUS_SOLD:
                return '#DC2626';
            case self.UNIT_STATUS_RESERVED:
            case self.UNIT_STATUS_BOOKED:
                return '#D97706';
            case self.UNIT_STATUS_LISTED:
                return '#16A34A';
            default:
                return '#686767';
        }
    }

    /**
     * Build the display label for a Block/Tower dropdown option, in the form
     * "<Block/Tower> — <Status> — <Price>". The status is an informational hint only;
     * the server still validates assignability on Proceed. WEB-3665.
     *
     * @param {Object} unit  A candidate unit.
     * @returns {string}     The option label.
     */
    getBlockOptionLabel(unit) {
        const self = this;

        if (!unit) return '';

        let label = unit.stack_name ? unit.stack_name : 'Block/Tower';
        if (unit.formatted_status) {
            label += ' — ' + unit.formatted_status;
        }
        if (unit.price) {
            label += ' — ' + self.SSUtilService.formatCurrency(unit.price);
        }
        return label;
    }

    /**
     * Combined handler for the unit-code input in the Assign Unit popup: refresh the
     * Block/Tower candidates first, then recompute the displayed price. WEB-3665.
     *
     * @returns {void}
     */
    onUpdateUnitNoChange() {
        const self = this;

        self.refreshUnitBlocks();
        self.getUpdatedPrice();
    }

    applySearch() {
        const self = this;

        self.loadEois(null);
    }

    applySort(eoisArray) {
        const self = this;

        if (!eoisArray) {
            return eoisArray;
        }

        if (self.current_phase === 'PostLaunch') {
            // PostLaunch - Descending on Application Date
            eoisArray.sort(function (x, y) {
                let d1 = x.application_date ? x.application_date : x.created_at;
                let d2 = y.application_date ? y.application_date : y.created_at;
                return d2.localeCompare(d1);
            });
        } else {
            // Before Post Launch - Ascending on Ballot No. or Application Date
            eoisArray.sort(function (x, y) {
                if (x.queue_no != y.queue_no) {
                    if (x.queue_no == null) {
                        return 1;
                    } else if (y.queue_no == null) {
                        return -1;
                    } else {
                        return x.queue_no - y.queue_no;
                    }
                } else {
                    if (x.eoi_no == y.eoi_no) {
                        return 0;
                    } else if (x.eoi_no == null) {
                        return 1;
                    } else if (y.eoi_no == null) {
                        return -1;
                    } else {
                        //return x.eoi_no.localeCompare(y.eoi_no);
                        let d1 = x.application_date ? x.application_date : x.created_at;
                        let d2 = y.application_date ? y.application_date : y.created_at;
                        return d1.localeCompare(d2);
                    }
                }
            });
        }

        return eoisArray;
    }

    isSearchApplied() {
        const self = this;

        return self.eoi_search
            || self.status_search
            || self.date_search
            || self.agency_search
            || self.household_type_search != null
            || self.amlPositiveCases
            || self.filter_cdd_acknowledgement;
    }

    getFilteredEois() {
        const self = this;

        if (!self.isSearchApplied()) {
            return angular.copy(self.allEoisMaster); // Return full master copy if no filters applied
        }

        let filteredEois = [];

        $.each(self.allEoisMaster, function (i, _eoi) {
            if (self.eoi_search
                && _eoi.eoi_no.toLowerCase().indexOf(self.eoi_search.toLowerCase().trim()) === -1
                && (!_eoi.unit_name || _eoi.unit_name.indexOf(self.eoi_search.trim()) === -1)
                && (!_eoi.ext_no || _eoi.ext_no.toLowerCase().indexOf(self.eoi_search.toLowerCase().trim()) === -1)
            ) {
                return; // Skip
            }

            if (self.status_search
                && _eoi.status != self.status_search
            ) {
                return; // Skip
            }

            if (self.date_search
                && self.date_search != self.SSUtilService.formatDateDMY(_eoi.application_date ? _eoi.application_date : _eoi.created_at)
            ) {
                return; // Skip
            }

            if (self.agency_search
                && _eoi.calculated_agency_id != self.agency_search
            ) {
                return; // Skip
            }

            if (self.household_type_search
                && _eoi.declared_household_type != self.household_type_search
            ) {
                return; // Skip
            }

            if (self.amlPositiveCases) {
                let hasPositiveMatch = null;
                if (_eoi.positive_aml_scans) {
                    hasPositiveMatch = true;
                    /** WEB-2880 DMS/AMS: EOIs Loading Issues
                     * Need to remove after ticket is moved
                     $.each(_eoi.aml_scans, function (j, aml) {
                        if (aml.result_count > 0) {
                            hasPositiveMatch = true;
                            return false; // Break
                        }
                    });*/
                }
                if (!hasPositiveMatch) return; // Skip
            }

            if(self.filter_cdd_acknowledgement){
                let hasCDDMatch = null;
                if (_eoi.show_cdd_acknowledgement) {
                    hasCDDMatch = true;
                }
                if (!hasCDDMatch) return; // Skip
            }

            filteredEois.push(_eoi); // Include in filtered results
        });

        return filteredEois;
    }

    /** WEB-2880 DMS/AMS: EOIs Loading Issues
     * Need to remove after ticket is moved
    getAmlPositiveCases(eois) {
        const self = this;

        let aml_eois = [];
        $.each(eois, function (i, eoi) {
            if (eoi.aml_scans) {
                $.each(eoi.aml_scans, function (j, aml) {
                    if (aml.result_count > 0) {
                        aml_eois.push(eoi);
                        return;
                    }
                });
            }
        });

        return aml_eois;
    }**/

    getHouseholdType(type) {
        const self = this;

        let name = '--';

        let household = self.HOUSEHOLD_TYPES.find(x => x.id == type);
        if (household) {
            name = household.name;
        }

        return name;
    }

    getUnits(show_loading = true) {
        const self = this;

        if (!self.data.property) return;

        self.units = null;

        let url = 'sec/developer/properties/' + self.data.property.id + '/units';

        let params = {
            'offset': 0,
            'limit': 99999
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.units = response.data.property_units;
            self.stacks = response.data.stacks;
            self.stampUnitsBlockInfo();
            self.getEoiPhase();
        });
    }

    /**
     * Stamp each loaded unit with its Block/Tower (stack) name and a human-readable
     * status label. The Assign Unit popup uses these to show "<Block/Tower> — <Status>"
     * for every unit that shares the same unit code (named_id) across different blocks,
     * so the user can disambiguate before assigning. WEB-3665.
     *
     * @returns {void}
     */
    stampUnitsBlockInfo() {
        const self = this;

        if (!self.units) return;

        self.units.forEach(function (unit) {
            let stack = self.findStack(unit.stack_id);
            unit.stack_name = stack ? stack.name : null;
            unit.formatted_status = self.SSConfigService.getUnitStatusName(unit.status);
        });
    }

    /**
     * Find a loaded stack (Block/Tower) by its id.
     *
     * @param {number} stackId  The unit's stack_id.
     * @returns {Object|null}   The matching stack, or null when not found.
     */
    findStack(stackId) {
        const self = this;

        if (!stackId || !self.stacks) return null;

        return self.stacks.find(x => x.id == stackId);
    }

    getUnitName(unit_id, appendSign = true) {
        const self = this;

        if (!unit_id || !self.units) return null;

        let unit = self.units.find(x => x.id == unit_id);
        if (unit) {
            return appendSign ? '#' + unit.named_id : unit.named_id;
        }

        return null;
    }

    getUnitSelectionTime(unit_id) {
        const self = this;

        if (!unit_id || !self.units) return;

        let unit = self.units.find(x => x.id == unit_id);
        if (unit && unit.selected_at) {
            return self.SSUtilService.formatLocalDateTime(unit.selected_at);
        }
    }

    getUnitSelectionElapsedTime(unit_id) {
        const self = this;

        if (!unit_id || !self.units) return;

        let unit = self.units.find(x => x.id == unit_id);
        if (unit && unit.selected_at) {
            return self.SSUtilService.getElapsedTime(unit.selected_at);
        }
    }

    getSelectedUnit(eoi) {
        const self = this;

        if (!eoi.eoi_units) return {};

        let unit = eoi.eoi_units[0];

        return unit ? unit : {};
    }

    /**
     * Resolves and displays the price of the unit typed into the Assign Unit popup,
     * honouring the selected payment plan's unit price schedule when one applies.
     *
     * Runs on every keystroke of the unit-number input (ng-change). Matches the
     * typed value against unit named_id ('#' ignored) for any non-empty input, so
     * bare 1/2-digit unit numbers (Terrace units without a floor level) resolve a
     * price as well as the standard #02-12 / 02-12 format (WEB-3766). The
     * "Unit not found." error is only raised once the input exceeds the standard
     * floor-unit format length, to avoid flashing errors mid-typing. When the code
     * exists in several Blocks/Towers the price is held until one is selected (WEB-3665).
     *
     * Also stamps selected_unit_status_name/_color once a single unit is resolved, so
     * the popup can flag a SOLD/RESERVED/BOOKED unit inline before Proceed, mirroring
     * the Flutter app's Assign Unit screen (WEB-3362).
     *
     * @returns {void} sets selected_unit_price / selected_unit_price_raw / update_unit_error
     *                 / selected_unit_status_name / selected_unit_status_color
     */
    getUpdatedPrice() {
        const self = this;

        if (!self.update_unit_no) return;

        self.update_unit_error = null;
        self.selected_unit_price = '--';
        self.selected_unit_price_raw = 0;
        self.selected_unit_status_name = null;
        self.selected_unit_status_color = null;

        // WEB-3766 — look up on any non-empty input so 1/2-digit unit numbers
        // (e.g. Terrace units without a floor level) resolve a price too
        let candidates = self.getUnitsByName(self.update_unit_no);

        if (candidates.length === 0) {
            // only flag "not found" past the floor-unit format length (#02-12),
            // so partial typing of a standard unit number doesn't flash an error
            if (self.update_unit_no.length > 4) {
                self.update_unit_error = "Unit not found.";
            }
            return;
        }

        // WEB-3665 — code shared across multiple Blocks/Towers but none picked yet:
        // hold the price until the user selects a Block/Tower.
        if (candidates.length > 1 && !self.selected_unit_block) {
            return;
        }

        let unit = self.resolveUpdateUnit();
        if (!unit) return;

        let price = unit.price;
        if (self.selected_payment_plan) {
            if (self.unit_price_schedules) {
                let price_plan = self.unit_price_schedules.find(x => x.id == self.selected_payment_plan.unit_price_schedule_id);
                if (price_plan) {
                    let unit_detail = price_plan.unit_price_schedule_details.find(x => x.unit_id == unit.id);
                    if (unit_detail) {
                        price = unit_detail.price;
                    }
                }
            }
            if (!price) price = unit.price;
        }
        self.selected_unit_price_raw = parseFloat(price) || 0; // WEB-3643 — raw price for clause-value calc
        self.selected_unit_price = self.SSUtilService.formatCurrency(price);

        // WEB-3362 — flag the resolved unit's status inline (colour-coded, mirrors the
        // Flutter app's Assign Unit screen). Informational only; the server remains the
        // real gate on Proceed (see assignUnits(), WEB-3508).
        self.selected_unit_status_name = unit.formatted_status;
        self.selected_unit_status_color = self.getUnitStatusColor(unit.status);
    }

    getUnitPriceByPricePlan(unit) {
        const self = this;

        let price = 0;

        if (unit && self.payment_plans.length) {
            price = unit.price;

            let payment_plan = self.payment_plans.find(x => x.id == unit.payment_plan_id);

            if (payment_plan) {
                if (self.unit_price_schedules) {
                    let price_plan = self.unit_price_schedules.find(x => x.id == payment_plan.unit_price_schedule_id);
                    if (price_plan) {
                        let unit_detail = price_plan.unit_price_schedule_details.find(x => x.unit_id == unit.id);
                        if (unit_detail) {
                            price = unit_detail.price;
                        }
                    }
                }
                if (!price) price = unit.price;
            }
        }

        return price;
    }

    // To show/hide Print EOI buttons
    isPrintButtonAllowed(eoi) {
        const self = this;

        return eoi.status == self.EOI_STATUS_SUBMITTED
            || eoi.status == self.EOI_STATUS_VERIFIED
            || eoi.status == self.EOI_STATUS_REGISTERED;
    }

    // To show/hide Send EOI Email buttons
    isSendEmailButtonAllowed(eoi) {
        const self = this;

        return self.SSUserService.hasPermissionForProperty('DMS_EOI_SEND_EMAIL', eoi.property_id)
            && (eoi.status == self.EOI_STATUS_SUBMITTED
                || eoi.status == self.EOI_STATUS_VERIFIED
                || eoi.status == self.EOI_STATUS_REGISTERED
            );
    }

    // To show/hide Send EOI Email buttons
    isEOIReviewButtonAllowed(eoi) {
        const self = this;

        return self.SSUserService.hasPermissionForProperty('DMS_EOI_REVIEW', eoi.property_id)
            && (eoi.status == self.EOI_STATUS_VERIFIED
                || eoi.status == self.EOI_STATUS_SUBMITTED
                || eoi.status == self.EOI_STATUS_REGISTERED
                || eoi.status == self.EOI_STATUS_SUCCESSFUL
            );
    }

    getAgencies() {
        const self = this;

        self.agencies = null;
        let params = {
            'format': 3
        };

        //loading(true);
        self.SSHttpService.getAPIRequest('agencies', params).then(function (response) {
            //loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data && response.data.agencies)) {
                return;
            }

            self.agencies = response.data.agencies;
        });
    }

    getAgencyName(agencyId) {
        const self = this;

        if (!agencyId || !self.agencies) return '--';

        let agency = self.agencies.find(x => x.id == agencyId);

        return agency ? agency.name : '';
    }

    getAgencyShortCode(agencyId) {
        const self = this;

        if (!agencyId || !self.agencies) return '--';

        let agency = self.agencies.find(x => x.id == agencyId);

        return agency ? agency.short_code : '';
    }

    hasPermission(property_id) {
        const self = this;

        let url = self.$window.location.href;

        if (!url) {
            self.permission_code = 'DMS_VW_EOI / DMS_PROJ_VIEW_EOI';
            return false;
        }

        try {
            // If url ends with 'eoi' then permission name is: DMS_VW_EOI
            // If url ends with 'eois' then permission name is: DMS_PROJ_VIEW_EOI
            if (url.endsWith('eoi')) {
                if (self.SSUserService.hasPermission('DMS_VW_EOI')) {
                    return true;
                } else {
                    self.permission_code = 'DMS_VW_EOI';
                    return false;
                }
            } else if (url.endsWith('eois')) {
                if (self.SSUserService.hasPermissionForProperty('DMS_PROJ_VIEW_EOI', property_id)) {
                    return true;
                } else {
                    self.permission_code = 'DMS_PROJ_VIEW_EOI';
                    return false;
                }
            } else {
                self.permission_code = 'DMS_VW_EOI / DMS_PROJ_VIEW_EOI';
                return false;
            }
        } catch (ex) {
            console.log(ex);
        }
    }

    /**
     * WEB-4720: the EOI total on this page is shown only with DMS_VW_EOI_COUNT on the selected
     * project (strictly per project, as the API checks it).
     */
    canViewEoiCount() {
        const self = this;
        const propertyId = self.property ? self.property.id : null;

        return self.SSUserService.hasPermissionForProperty('DMS_VW_EOI_COUNT', propertyId);
    }

    // CLIENT SIDE PAGINATION
    loadEois(page) {
        const self = this;

        let eois = self.getFilteredEois();
        eois = self.applySort(eois);
        eois = eois ? eois : []; // Init empty array to avoid any errors

        let limitIntValue = parseInt(self.limit);
        page = page ? page : self.selectedPage;
        self.offset = (page > 0 ? (page - 1) : 0) * limitIntValue;
        self.count = eois.length;

        self.allEoisByPhase = eois.slice(self.offset, limitIntValue + self.offset);

        // SET 'CURRENT SELECTED EOIS' COUNT
        if (limitIntValue < self.allEoisByPhase.length) {
            self.selected_eois_count = limitIntValue;
        } else {
            self.selected_eois_count = self.allEoisByPhase.length;
        }

        if (self.count == 0) {
            return;
        }

        self.selectedPage = Math.floor(self.offset / limitIntValue) + 1;

        // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
        self.total_pages = Math.ceil(self.count / limitIntValue);
        self.setTotalPagesOptions(self.total_pages);
    }

    getEois() {
        const self = this;

        let page = 1;
        if (!self.selectedRows) {
            self.limit = self.allEoisMaster.length;
        } else {
            self.limit = parseInt(self.selectedRows);
        }

        self.loadEois(page);
    }

    returnForAmendments(eoi){
        const self = this;
        self.dev_amendments_remarks = "";
        self.eoiParams = angular.copy(eoi);

        $('#returnForAmendmentsModal').modal('show');
    }

    _returnForAmendments(){
        const self = this;

        let url = 'sec/eois/' + self.eoiParams.id + '/status';
        let params = {
            status: self.EOI_STATUS_SUBMITTED,
            remarks: self.dev_amendments_remarks
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            $('#returnForAmendmentsModal').modal('hide');

            let response_eoi = response.data.eoi;

            $.each(self.allEoisMaster, function (i, _eoi) {
                if (_eoi.id === self.eoiParams.id ) {
                    _eoi.status = response_eoi.status;
                    _eoi.remarks = response_eoi.remarks;

                    /** WEB-3111 DMS: All EOIs page - Add return button on Review page **/
                    self.risk_assessment_eoi = angular.copy(_eoi);
                }
            });

            self.SSAlertService.success('Success!', 'EOI updated successfully.');
            self.loadEois();
        });
    }

    pagesGoBack() {
        const self = this;

        self.selectedPage--;
        self.offset = self.offset - parseInt(self.limit);
        self.loadEois();
    }

    pagesGoNext() {
        const self = this;

        self.selectedPage++;
        self.offset = self.offset + parseInt(self.limit);
        self.loadEois();
    }

    gotoPage(pageNum) {
        const self = this;

        self.loadEois(pageNum);
    }

    isVerifiedEoi(eoi) {
        const self = this;

        if (!eoi) {
            return false;
        }

        if (eoi.status == self.EOI_STATUS_VERIFIED
            || eoi.status == self.EOI_STATUS_REGISTERED
            || eoi.status == self.EOI_STATUS_SUCCESSFUL
            || eoi.status == self.EOI_STATUS_UNSUCCESSFUL
            || eoi.status == self.EOI_STATUS_COMPLETED) {
            return true;
        } else {
            return false;
        }
    }

    isRegisteredEoi(eoi) {
        const self = this;

        if (!eoi) {
            return false;
        }

        if (eoi.status == self.EOI_STATUS_REGISTERED
            || eoi.status == self.EOI_STATUS_SUCCESSFUL
            || eoi.status == self.EOI_STATUS_UNSUCCESSFUL
            || eoi.status == self.EOI_STATUS_COMPLETED) {
            return true;
        } else {
            return false;
        }
    }

    isCompletedEoi(eoi) {
        const self = this;

        if (!eoi) {
            return false;
        }

        if (eoi.status == self.EOI_STATUS_COMPLETED) {
            return true;
        } else {
            return false;
        }
    }

    isBallotedEoi(eoi) {
        const self = this;

        if (!eoi) {
            return false;
        }

        if ((eoi.status == self.EOI_STATUS_REGISTERED
            || eoi.status == self.EOI_STATUS_SUCCESSFUL
            || eoi.status == self.EOI_STATUS_UNSUCCESSFUL
            || eoi.status == self.EOI_STATUS_COMPLETED) && eoi.queue_no != null) {
            return true;
        } else {
            return false;
        }
    }

    getPaymentPlans() {
        const self = this;

        if (!self.data.property) return;

        let url = 'sec/developer/properties/' + self.data.property.id + '/payment-plans';
        let params = {
            // WEB-3643 — payment_plan_clauses needed to render the inline customise clause/rule table.
            include: 'unit_price_schedules,payment_plan_clauses'
        };

        //loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            //loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.payment_plans && response.data.payment_plans.length > 0) {
                self.payment_plans = response.data.payment_plans;
                self.unit_price_schedules = response.data.unit_price_schedules;
            }
        });
    }

    toggleSelectAllEois() {
        const self = this;

        self.eois_count_for_emails = 0;
        let checked = event.target.checked;

        if (checked) {
            let eois = self.getFilteredEois();

            $.each(eois, function (index, eoi) {
                if (eoi.status == self.EOI_STATUS_SUBMITTED
                    || eoi.status == self.EOI_STATUS_VERIFIED
                    || eoi.status == self.EOI_STATUS_REGISTERED) {
                    self.selected_eois[eoi.id] = true;
                    self.eois_count_for_emails++;
                }
            });
        } else {
            self.selected_eois = {};
        }
    }

    updateSelectedEois(eoi) {
        const self = this;

        let checked = event.target.checked;

        if (checked)
            self.eois_count_for_emails++;
        else
            self.eois_count_for_emails--;
    }

    sendEmails() {
        const self = this;

        if (!self.eois_count_for_emails) {
            self.SSAlertService.warning('Warning!', 'Please select EOI(s).');
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            "Are you sure you want to send EOI Letter emails to buyers of selected EOI(s)?",
            self.SSConfirmationService.TYPE_YES_NO,
            function (confirmationStatus) {

                let eoi_ids = [];

                $.each(self.selected_eois, function (eoi_id, is_selected) {
                    if (is_selected) {
                        eoi_ids.push(parseInt(eoi_id));
                    }
                });

                self.sendEoiEmails(eoi_ids.join());
            }
        );
    }

    sendEoiEmails(eoi_ids) {
        const self = this;

        // Need to update url
        let url = 'sec/eois/bulk-eois-emails';

        let params = {
            eoi_ids: eoi_ids
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'EOI letters added to email queue successfully.');
        });
    }

    initEOisStatuses() {
        const self = this;

        self.EOIS_STATUSES = [
            {'id': self.EOI_STATUS_DRAFT, 'name': 'Draft', 'className': 'text-primary'},
            {'id': self.EOI_STATUS_TRANSFERRED, 'name': 'Transferred', 'className': 'text-primary'},
            {'id': self.EOI_STATUS_SUBMITTED, 'name': 'Submitted', 'className': 'text-success'},
            {'id': self.EOI_STATUS_VERIFIED, 'name': 'Verified', 'className': 'text-primary'},
            {'id': self.EOI_STATUS_WITHDRAWN, 'name': 'Withdrawn', 'className': 'text-success'},
            {'id': self.EOI_STATUS_REJECTED, 'name': 'Rejected', 'className': 'text-danger'},
            {'id': self.EOI_STATUS_REGISTERED, 'name': 'Registered', 'className': 'text-primary'},
            {'id': self.EOI_STATUS_SUCCESSFUL, 'name': 'Successful', 'className': 'text-success'},
            {'id': self.EOI_STATUS_UNSUCCESSFUL, 'name': 'Unsuccessful', 'className': 'text-danger'},
            {'id': self.EOI_STATUS_COMPLETED, 'name': 'Completed', 'className': 'text-success'},
        ];
    }

    getEoiStatusName(eoiStatus) {
        const self = this;

        // Set 'default' value as Draft
        let name = '';

        let status = self.getEoiStatus(eoiStatus);

        if (status) {
            name = status.name;
        }

        return name;
    }

    getEoiStatus(eoiStatus) {
        const self = this;

        let status = null;

        if (!eoiStatus) {
            return status;
        }

        try {
            status = self.EOIS_STATUSES.find(x => x.id == eoiStatus);
        } catch (ex) {
            console.log(ex);
        }

        return status;
    }

    getEoiStatusClass(eoiStatus) {
        const self = this;

        let className = 'text-primary';

        let status = self.getEoiStatus(eoiStatus);
        if (status) {
            className = status.className;
        }

        return className;
    }

    getHouseholdClass(value) {
        const self = this;

        let className = 'text-primary';
        if (value == self.HOUSEHOLD_TYPE_FIRST_TIMER) {
            className = 'text-success';
        } else if (value == self.HOUSEHOLD_TYPE_SECOND_TIMER) {
            className = 'text-primary';
        }

        return className;
    }

    getUnitNumber(unit) {
        const self = this;

        // WEB-3643 — guard against undefined unit (EOI Discounts partial binds eoiUnit.unit which can be
        // undefined → "Cannot read properties of undefined (reading 'length')" console errors during digest).
        if (!unit || unit.length < 1) {
            return '-';
        }
        return self.SSUtilService.getFullUnitNumber1(unit, false);
    }

    downloadAMLResults() {
        const self = this;

        let url = "sec/developer/eois/download?property_id=" + self.data.property.id + "&property_launch_id=" + self.data.phase_id + "&status=" + self.eoiStatusesForExport;
        url = self.SSHttpService.getApiURL(url);
        self.$window.location.href = url;
        self.SSAlertService.success('Success!', 'AML results downloaded successfully.');
    }

    downloadAMLDocuments() {
        const self = this;

        let url = "sec/developer/eois/download?property_id=" + self.data.property.id + "&property_launch_id=" + self.data.phase_id + "&status=" + self.eoiStatusesForExport;
        url = self.SSHttpService.getApiURL(url);
        self.$window.location.href = url;
        self.SSAlertService.success('Success!', 'AML documents downloaded successfully.');
    }

    exportEois() {
        const self = this;

        let url = "sec/developer/eois/download?property_id=" + self.data.property.id + "&property_launch_id=" + self.data.phase_id + "&status=" + self.eoiStatusesForExport;
        url = self.SSHttpService.getApiURL(url);
        self.$window.location.href = url;
        self.SSAlertService.success('Success!', 'EOIs export successfully.');
    }

    downloadSingleEoi(eoi) {
        const self = this;

        let url = self.SSHttpService.getApiURL('sec/eois/' + eoi.id + '/print');
        window.open(url, '_blank');

        self.SSAlertService.success("Success!", "Download completed successfully");
    }

    downloadPPForm(eoi) {
        const self = this;

        if (!eoi) return;

        let url = self.getPPFormUrl(eoi);
        window.open(url, '_blank');

        self.SSAlertService.success("Success!", "Download completed successfully");
    }

    getPPFormUrl(eoi) {
        const self = this;

        return self.SSHttpService.getApiURL('sec/eois/' + eoi.id + '/buyer-particulars-pdf');
    }

    emailSingleEoi(eoi) {
        const self = this;

        let url = 'sec/eois/' + eoi.id + '/print-and-email';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSConfirmationService.getConfirmed(
                'Success!',
                "Email sent to the Buyer(s) successfully.",
                self.SSConfirmationService.TYPE_OK,
                function (confirmationStatus) {

                }
            );
        });
    }

    setTotalPagesOptions(TOTAL_PAGES) {
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for (var index = 0; index < TOTAL_PAGES; index++) {
            self.TOTAL_PAGES_OPTIONS.push(index);
        }
    }

    /* WEB-2835 Key Handover: Final AML Scans and Form F */
    checkIfQuestionsHaveMarker(marker){
        const self = this;
        if(!self.questions) { return false; }

        return self.questions.filter(q => self.SSUtilService.compareQuestionMarker(q.marker, marker)).length > 0;
    }

    /** The-Review-pages,-the-IC-and-Cheque-images-were-not-showing **/
    parseDate(date) {
        const self = this;

        const parsed = Date.parse(date);
        if (!isNaN(parsed)) {
            return parsed;
        }

        return Date.parse(date.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
    }

    /** WEB-2900 AML Scan: GuocoLand Feedback **/
    getDefaultTxtForAmlRemarks(){
        const self = this;

        let remarks = "";
        if(self.sale){
            if(self.sale.buyers && self.sale.buyers.length){
                self.sale.buyers.forEach((beneficiary, i)=>{
                    remarks+= (i>0)? "\n": "";
                    remarks+="Buyer "+ (i+1) +":";
                })
            }

            if(self.sale.beneficiaries && self.sale.beneficiaries.length){
                remarks+= "\n";

                self.sale.beneficiaries.forEach((beneficiary, i)=>{
                    remarks+= (i>0)? "\n": "";
                    remarks+="Beneficiary "+ (i+1) +":";
                })
            }

            if(self.sale.non_buyer_payees && self.sale.non_buyer_payees.length){
                remarks+= "\n";

                self.sale.non_buyer_payees.forEach((non_buyer_payee, i)=>{
                    remarks+= (i>0)? "\n": "";
                    remarks+="3rd Party Payor "+ (i+1) +":";
                })
            }
        }

        return remarks;
    }

    /** WEB-2901 FATF Black List - Indications - START **/
    getDeveloperSettings(){
        const self = this;

        let url = 'sec/developer/settings';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.developer_settings){
                let fatf_blacklist_countries_settings = self.SettingsService.getSetting(response.data.developer_settings, 'fatf_blacklist_countries');
                let occupations_blacklist_settings = self.SettingsService.getSetting(response.data.developer_settings, 'blacklist_occupations');
                let cbi_rbi_countries_settings = self.SettingsService.getSetting(response.data.developer_settings, 'cbi_rbi_countries');
                if(fatf_blacklist_countries_settings
                    && fatf_blacklist_countries_settings.value
                    && fatf_blacklist_countries_settings.value.length){
                    self.fatf_blacklist_countries = fatf_blacklist_countries_settings.value;
                }
                if(cbi_rbi_countries_settings
                    && cbi_rbi_countries_settings.value
                    && cbi_rbi_countries_settings.value.length){
                    self.cbi_rbi_countries = cbi_rbi_countries_settings.value;
                }
                if(occupations_blacklist_settings
                    && occupations_blacklist_settings.value
                    && Object.keys(occupations_blacklist_settings.value).length) {
                    self.occupations_blacklist = occupations_blacklist_settings.value;
                }
            }
        })
    }

    checkBuyersAgainstFatfList(){
        /** WEB-2901 FATF Black List - Indications
         * Add indicator to buyer(buyer, beneficiary, 3rd Party Payor) object
         * if country_of_origin or nationality lies in FATF blacklist **/
        const self = this;

        if(!self.sale){ return false; }

        if(self.sale.buyers && self.sale.buyers.length){
            self.sale.buyers= self.sale.buyers.map((buyer)=>{
                if(buyer.individual){
                    if(buyer.individual.country_of_origin
                        && self.fatf_blacklist_countries.indexOf(buyer.individual.country_of_origin) > -1){
                        buyer.is_from_fatf_blacklisted_country = true;
                    }
                    if(buyer.individual.nationality
                        && self.fatf_blacklist_countries.indexOf(buyer.individual.nationality) > -1){
                        buyer.is_from_fatf_blacklisted_country = true;
                    }

                    /** WEB-3061 Citizenship by Investment (CBI) and Residency by Investment (RBI) programs
                     * Show indicator if country or nationality in cbi/rbi list **/
                    if(buyer.individual.country_of_origin
                        && self.cbi_rbi_countries.indexOf(buyer.individual.country_of_origin) > -1){
                        buyer.is_from_cbi_rbi_country = true;
                    }
                    if(buyer.individual.nationality
                        && self.cbi_rbi_countries.indexOf(buyer.individual.nationality) > -1){
                        buyer.is_from_cbi_rbi_country = true;
                    }

                    /** WEB-3058 Black List Occupations
                     * Show indicator if buyer occupation is in blacklist **/
                    if (buyer.individual.industry
                        && self.occupations_blacklist[buyer.individual.industry]
                        && self.occupations_blacklist[buyer.individual.industry].length) {
                        if (buyer.individual.occupation
                            && self.occupations_blacklist[buyer.individual.industry].indexOf(buyer.individual.occupation) > -1){
                            buyer.has_blacklisted_occupation = true;
                        }
                    }
                } else if(buyer.company){
                    if(buyer.company.nationality
                        && self.fatf_blacklist_countries.indexOf(buyer.company.nationality) > -1){
                        buyer.is_from_fatf_blacklisted_country = true;
                    }
                    if(buyer.company.nationality
                        && self.cbi_rbi_countries.indexOf(buyer.company.nationality) > -1){
                        buyer.is_from_cbi_rbi_country = true;
                    }
                }
                return buyer;
            })

        }
        if(self.sale.beneficiaries && self.sale.beneficiaries.length){
            self.sale.beneficiaries= self.sale.beneficiaries.map((beneficiary)=>{
                if(beneficiary.country_of_origin
                    && self.fatf_blacklist_countries.indexOf(beneficiary.country_of_origin) > -1){
                    beneficiary.is_from_fatf_blacklisted_country = true;
                }
                if(beneficiary.nationality
                    && self.fatf_blacklist_countries.indexOf(beneficiary.nationality) > -1){
                    beneficiary.is_from_fatf_blacklisted_country = true;
                }

                if(beneficiary.country_of_origin
                    && self.cbi_rbi_countries.indexOf(beneficiary.country_of_origin) > -1){
                    beneficiary.is_from_cbi_rbi_country = true;
                }
                if(beneficiary.nationality
                    && self.cbi_rbi_countries.indexOf(beneficiary.nationality) > -1){
                    beneficiary.is_from_cbi_rbi_country = true;
                }
                return beneficiary;
            })
        }
        if(self.sale.non_buyer_payees && self.sale.non_buyer_payees.length){
            self.sale.non_buyer_payees= self.sale.non_buyer_payees.map((non_buyer_payee)=>{
                if(non_buyer_payee.individual){
                    if(non_buyer_payee.individual.country_of_origin
                        && self.fatf_blacklist_countries.indexOf(non_buyer_payee.individual.country_of_origin) > -1){
                        non_buyer_payee.is_from_fatf_blacklisted_country = true;
                    }
                    if(non_buyer_payee.individual.nationality
                        && self.fatf_blacklist_countries.indexOf(non_buyer_payee.individual.nationality) > -1){
                        non_buyer_payee.is_from_fatf_blacklisted_country = true;
                    }

                    if(non_buyer_payee.individual.country_of_origin
                        && self.cbi_rbi_countries.indexOf(non_buyer_payee.individual.country_of_origin) > -1){
                        non_buyer_payee.is_from_cbi_rbi_country = true;
                    }
                    if(non_buyer_payee.individual.nationality
                        && self.cbi_rbi_countries.indexOf(non_buyer_payee.individual.nationality) > -1){
                        non_buyer_payee.is_from_cbi_rbi_country = true;
                    }

                    /** WEB-3058 Black List Occupations
                     * Show indicator if 3rd Party Payor occupation is in blacklist **/
                    if (non_buyer_payee.individual.industry
                        && self.occupations_blacklist[non_buyer_payee.individual.industry]
                        && self.occupations_blacklist[non_buyer_payee.individual.industry].length) {
                        if (non_buyer_payee.individual.occupation
                            && self.occupations_blacklist[non_buyer_payee.individual.industry].indexOf(non_buyer_payee.individual.occupation) > -1){
                            non_buyer_payee.has_blacklisted_occupation = true;
                        }
                    }
                } else if(non_buyer_payee.company){
                    if(non_buyer_payee.company.nationality
                        && self.fatf_blacklist_countries.indexOf(non_buyer_payee.company.nationality) > -1){
                        non_buyer_payee.is_from_fatf_blacklisted_country = true;
                    }

                    if(non_buyer_payee.company.nationality
                        && self.cbi_rbi_countries.indexOf(non_buyer_payee.company.nationality) > -1){
                        non_buyer_payee.is_from_cbi_rbi_country = true;
                    }
                }
                return non_buyer_payee;
            })

        }
    }
    /** WEB-2901 FATF Black List - Indications - END **/

    /** WEB-2912 Unit Reserve Price **/
    getSellingPriceAfterDiscount(eoiUnit){
        /** Show reserve price if discounted price falls below reserve prive **/
        const self = this;
        self.isReservePriceApplied = false;

        return eoiUnit.price - self.getTotalDiscountedAmount(eoiUnit, true);

        /** REVERT THIS CHANGE: WEB-2912 Unit Reserve Price don't need to show the reserve price **/
        // if( eoiUnit.unit && eoiUnit.unit.reserve_price
        //         && (discountedPrice < eoiUnit.unit.reserve_price) ){
        //     discountedPrice = eoiUnit.unit.reserve_price;
        //     self.isReservePriceApplied = true;
        // }
    }

    /**
     * Download the EOI export for the current phase from the reports server: the Unit x choice
     * matrix, one row per EOI choice, the Stack / Bedroom Type breakdowns and the Elevation Chart.
     *
     * WEB-4671 folded the separate EOI Raw Data download (WEB-4461) into this one, so the page has
     * a single button again; the selector beside it picks what the counting sheets cover.
     *
     * @param {string} choiceMode 'first' (1st choice only) or 'all' (every choice) - the same
     *                            counting as the heatmap's "Show by First / All Choices".
     */
    downloadEOIChoicesByUnit(choiceMode){
        const self = this;
        let propertyId = self.data.property.id;
        let launchId = self.data.phase_id;
        if(!propertyId || !launchId){
            this.SSAlertService.error("Error!", "Launch Selection is required.");
            return;
        }
        let url = self.SSHttpService.getReportURL('api/reports/eoi-export-choices-by-unit-report');
        url += '&property_id='+propertyId;
        url += '&property_launch_id='+launchId;
        url += '&choice_mode=' + (choiceMode === 'first' ? 'first' : 'all');
        let url_ping = window.open(url,'_blank');
        if(url_ping)
        {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
    }

}

DeveloperPropertyEoiPhaseController.$inject = ['$scope','$localStorage', '$window', '$timeout', '$filter', 'SSHttpService', 'SSConfigService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSConfirmationService', 'SSUserService', 'SettingsService', 'SSEoiService', 'SSEoiDiscountsService'];
app.controller('DeveloperPropertyEoiPhaseController', DeveloperPropertyEoiPhaseController);

// WEB-4411/WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js.
// A copy here would link it a second time on every element.